/* eslint-disable max-len */
module.exports = {
  aOfB: '{a}/{b}',
  about: 'Tietoa',
  aboutThisItem: 'Tästä nimikkeestä',
  accessApiKeyManager: 'Käytä API-avaimen hallinnointia tälle vuokralaiselle.',
  accessControls: 'Käyttöoikeudet',
  accessControlsCopiedText: 'Käyttöoikeudet päivitetään välittömästi. Median suojausoikeudet päivitetään muutaman minuutin kuluessa.',
  accessControlsCopiedTitle: 'Käyttöoikeuksien kopiointi onnistui',
  accessControlsCopyConfirmation: 'Tämä poistaa kaikki olemassa olevat käyttöoikeudet kohteesta {to} ja korvaa ne kohteen {from} käyttöoikeuksilla. Tätä toimintoa ei voi kumota.',
  accessControlsDescription: 'Käyttöoikeudet määrittävät Organisaatioiden ja Mediakategorioiden perusteella, kenellä on oikeus nähdä tämä media.',
  accessControlsHelpText: 'Hallinnoi tämän organisaation käyttöoikeuksia. Käyttäjät pääsevät käyttämään vain lueteltuja medioita, jos heillä on lupa nähdä mediakategorioita, joihin kukin media kuuluu. Usean median käyttöön ottamisen käsittely organisaatiossa voi kestää jonkin aikaa. Odota hetki, ennen kuin muutokset astuvat voimaan ja käytä päivityspainiketta.',
  accessControlsIndeterminance: 'Huom.: Yläorganisaatioilla on aina pääsy sisältöön, joka on kohdistettu niiden alaorganisaatioihin.',
  accessControlsRefreshWarning: 'Sinulla on tallentamattomia muutoksia. Päivittäminen hylkää ne. Haluatko jatkaa?',
  accessControlsSaveSuccess: 'Käyttöoikeuksien tallennus onnistui.',
  accessControlsTitleSection: 'Kun käyttöoikeudet otetaan käyttöön tälle organisaatiolle, ne valtuutetaan myös automaattisesti seuraaville organisaatioille käänteisen periytymisen kautta:',
  accessControlsTooltip: 'Organisaatioilla on myös käyttöoikeus sisältöön, joihin niiden alemmilla organisaatioilla on käyttöoikeus. Alla oleva ruudukko ei sisällä sisältöä, johon tällä organisaatiolla on käyttöoikeus epäsuoran ylöspäin suuntautuvan valtuuttamisen tai käänteisen periytymisen kautta.',
  account: 'Tili',
  accountErrorMessage: 'Tilin virheviesti',
  accountErrorMessageWarning: 'Tietokannan tilinVirheviesti asetetaan vuokralaiselle arvoon ”Ei lupaa”.',
  action: 'Toimintoa | Toimintoja',
  actionDelete: 'poista',
  actionLoad: 'lataa',
  actionPaste: 'Kopioi',
  actionRun: 'suorita',
  actionSave: 'Tallenna',
  actionUndoWarning: 'Tätä toimintoa ei voi kumota.',
  actionUpload: 'siirrä',
  actualSize: 'Todellinen Koko',
  add: 'Lisää',
  addABookText: 'Lisää kirja',
  addABookToStart: '{addABookText}, niin pääset alkuun.',
  addAForm: 'Aloita lisäämällä Lomake',
  addAFormOnly: 'Lisää lomake',
  addAMedia: 'Lisää media',
  addAPIKey: 'Lisää API-avain',
  addAPartCollection: 'Lisää {partCollection} aloittaaksesi',
  addAPrintSettingText: 'Lisää Tulostusasetus',
  addAPrintSettingToStart: '{addAPrintSettingText}, niin pääset alkuun.',
  addASharedCart: 'Lisää jaettu ostoskoriy',
  addATag: 'Lisää merkki',
  addATemplate: 'Lisää malli',
  addAllPartsCart: 'Lisää kaikki osat ostoskoriin',
  addAnOrderQuoteEmailFormat: 'Lisää lomakkeen/tarjouksen sähköpostimuoto',
  addBooks: 'Lisää Kirjoja',
  addBrowseFlow: 'Lisää selausjärjestys',
  addChapter: 'Lisää luku',
  addChildBrowseFlow: 'Lisää Alatason Selausjärjestys',
  addComment: 'Lisää kommentti',
  addExistingPart: 'Lisää Olemassa Oleva Osa',
  addGroupsToUsers: 'Lisää ryhmiä {groups} käyttäjiin {users}',
  addItem: 'Lisää {item}',
  addMedia: 'Lisää Media',
  addPages: 'Lisää Sivuja',
  addPart: 'Lisää Osa',
  addReports: 'Lisää raportteja',
  addRootBrowseFlow: 'Lisää Juuriselausjärjestys',
  addRow: 'Lisää rivi',
  addTemplates: 'Lisää mallit',
  addToCartMessage: '{partNumber} lisättiin onnistuneesti',
  addToUserGroup: 'Lisää Ryhmiin',
  addWidgetKey: 'Lisää widget-avain',
  addedOn: 'Lisätty',
  additionalInformation: 'Lisätiedot',
  additionalNotification: 'Lisäilmoitus',
  additionalPartNumberDescription: 'Käytä osanumeron lisäkenttänä',
  address: 'Osoite | Osoitteet',
  addressInUse: 'Osoite on tällä hetkellä asetettuna oletusosoitteeksi, jota ei voi poistaa',
  addressInUseSubtitle: 'Jos haluat poistaa tämän osoitteen, sinun on ensin poistettava sen oletusarvoisuus.',
  addressLine: 'Osoiterivi {number}',
  addressState: {
    confirmationMessage: 'Seuraavia osoitteita ei ole vahvistettu.',
    confirmationTitle: 'Haluatko varmasti jatkaa vahvistamattomien osoitteiden kanssa?',
    disabledVerification: 'Osoitteiden vahvistus poistetaan käytöstä kyseiselle kentälle tilausta tai tarjousta lähetettäessä',
    enteredAddress: 'Syötetty osoite',
    failedToFetchSuggestions: 'Osoite-ehdotusten noutaminen epäonnistui.',
    failedToLoadDetails: 'Osoitetietojen lataaminen epäonnistui.',
    incomplete: 'Puutteellinen osoite',
    missingSubpremise: 'Puuttuva huoneistotieto',
    noSuggestions: 'Ehdotuksia ei löytynyt. Muokkaa osoitetta saadaksesi ehdotuksia.',
    selectAddress: '(valitse yksi vaihtoehto)',
    subpremiseMessage: 'Tämä osoite vaikuttaa olevan asuin- tai toimistorakennus. Lisää huoneisto-, asunto- tai toimistonumero täydentääksesi osoitteen.',
    suggested: 'Ehdotetut osoitteet',
    unverified: 'Vahvistamaton osoite',
    unverifiedHelpText: 'Valitse toinen tallennettu osoite, muokkaa tätä osoitetta tai lisää uusi osoite',
    unverifiedMessage: 'Emme voi vahvistaa tätä osoitetta toimitusta varten.',
    verified: 'Vahvistettu osoite'
  },
  admin: 'Hallinta',
  adminCenter: 'Hallintakeskus',
  adminCenterBanner: {
    bodyLabel: 'Bannerin runko',
    enableLabel: 'Aktivoi hallintabanneri',
    headerGreenOption: 'Vihreä',
    headerLabel: 'Bannerin otsikko',
    headerRedOption: 'Punainen',
    headerYellowOption: 'Keltainen',
    title: 'Hallintakeskuksen banneri',
    typeLabel: 'Bannerin tyyppi'
  },
  adminCenterMessage: 'Sisällön, käyttäjien, kirjastoasetusten, raportoinnin ja viennin hallintakeskus',
  adminMessage: 'Ominaisuuksia lisätään niiden tullessa saataville',
  administration: 'Hallinta',
  advancedFilters: 'Edistyneet suodattimet',
  affectedBookMedia: '{count} Kirjamedia päivitetään.',
  affectedProductPages: '{count} tuotesivua päivitetään.',
  affectedTemplateMedia: '{count} Kirjamallit päivitetään.',
  after: 'Jälkeen',
  aggregatedFromChildren: 'Koostettu Alatasoilta',
  aiAlgorithm: 'Tekoälyskanneri',
  algorithm: 'Algoritmi',
  alignHorizontal: 'Kohdista Vaakasuora',
  alignVertical: 'Kohdista Pystysuora',
  all: 'Kaikki',
  allLibraryPages: 'Kaikki kirjaston sivut',
  allPagesAndBooks: 'Kaikki sivut ja kirjat',
  allUsersDisabled: 'Kaikki vuokralaiselle kuuluvat käyttäjät poistetaan käytöstä.',
  alphanumeric: 'Aakkosnumeerinen',
  analyticsJSON: 'Analytiikka JSON',
  andCountMore: 'ja {count} lisää...',
  announcement: 'Ilmoitus | Ilmoitukset',
  any: 'Mikä tahansa',
  apiAuthHeader: 'API-valtuutusotsikko',
  apiKey: 'API-avain | API-avaimet',
  apiKeyAdmin: 'API Key Admin',
  apiKeyCopied: 'API-valtuutusotsikon arvo kopioitu leikepöydälle',
  apiKeyDeleteMsg: 'Tämän API-avaimen poistaminen estää sen käytön integroinneilla',
  apiKeyDeleteTitle: 'Oletko varma, että haluat poistaa tämän API-avaimen?',
  apiKeyDeleted: 'API-avain poistettu',
  apiKeyDeletedError: 'Virhe API-avaimen poistossa',
  apiKeyInstructions: 'Avain luodaan Tallennettaessa',
  apiKeyManager: 'API-avaimen Haltija',
  apiKeyNameEmpty: 'Nimi ei voi olla tyhjä',
  apiKeyRegenError: 'Virhe API-avaimen regeneroinnissa',
  apiKeyRegenMsg: 'Tämän API-avaimen palauttaminen voi poistaa käytöstä olemassa olevat integraatiot',
  apiKeyRegenTitle: 'Oletko varma, että haluat palauttaa tämän API-avaimen?',
  apiKeySaved: 'API-avain Tallennettu',
  apiKeyType: 'API-avaintyyppi',
  appliesTo: 'Koskee Seuraavia',
  appliesToEmpty: 'Edellyttää ainakin yhtä valittua kokonaisuustyyppiä',
  appliesToPopulated: 'Aseta, mihin kokonaisuuksiin tagia käytetään',
  apply: 'Käytä',
  applyItem: 'Käytä {item}',
  applyToChildItems: 'Sovella alatasoon {item}',
  applyToPartOnly: 'Käytä vain tähän osaan',
  april: 'Huhtikuu',
  areYouSure: 'Oletko varma, että haluat poistaa kohteen {item}?',
  areYouSureCopy: 'Oletko varma, että haluat kopioida kohteen {item}?',
  areYouSureYouWantToDisableTheTenant: 'Haluatko varmasti poistaa vuokralaisen käytöstä?',
  area: 'Alue',
  assembly: 'Kokoonpano | Kokoonpanot',
  assemblyConfirmationTitle: 'Haluatko päättää kokoonpanon luonnin?',
  assemblyCreatorHelpText1: 'Tämän toiminnon avulla voit lisätä valitun sivun kirjoihin kaikkialla, missä tämä osa {partName} on, ja yhdistää osan ja valitun sivun automaattisesti kohdepistelinkin välityksellä. Voit halutessasi rajoittaa lisäämisen vain valittuihin kirjoihin.',
  assemblyCreatorHelpText2: 'Valittu sivu lisätään kerran per kirja sen jälkeen, kun {partName} on esiintynyt ensimmäisen kerran.',
  assemblyCreatorSuccessSubtitle: 'Hotpoint-linkit ja muutokset kirjan sisällysluetteloon tehdään välittömästi. Hakutulokset näkyvät, kun indeksointi on valmis.',
  assemblyCreatorSuccessTitle: 'Kokoonpanon luontityö lähetetty',
  assemblyStepOne: 'Vaihe 1: Valitse lisättävä sivu',
  assemblyStepTwo: 'Vaihe 2: Valitse kirjat, joihin haluat lisätä sivun',
  asset: 'Omaisuus | Omaisuudet',
  assetsNotFound: 'Kohdetta {type} Ei Löytynyt',
  assignBrowseFlow: 'Kohdista Selausjärjestys',
  assignMedia: 'Nimeä media',
  assignMediaToItem: 'Nimeä media tälle: {item}.',
  assignedOrganizations: 'Kohdistetut Organisaatiot',
  associateProductPage: 'Liitä olemassa oleva tuotesivu',
  associateProductPageDescription: 'Liitä tuotesivut tähän mediaan.',
  associateProductPageTip: 'Vinkki: Napsauttamalla ”Create New Product Page” avautuu välilehti uuden tuotesivun lisäämistä varten, jos liitettävää tuotetta ei ole vielä olemassa. Sinun on silti palattava tälle sivulle liittääksesi uuden tuotesivun sen luomisen jälkeen.',
  associateProducts: 'Liitä tuotteet',
  atLeastFiveError: 'Valitse arvo, joka on vähintään 5.',
  attachRelatedPDFs: 'Liitä liittyvien osasivujen PDF:t',
  attachment: 'Liite | Liitteet',
  attachmentEditorDescription: 'Liitä kuvia, videoita ja asiakirjoja suoraan tähän kokonaisuuteen. Huomaa, että ne löytyvät "Liittyvä"-välilehdeltä.',
  attachmentEditorDescriptionPP: 'Liitä kuvia, videoita ja asiakirjoja suoraan tähän kokonaisuuteen.',
  attachmentFileUploadSizeError: 'Tiedostokoko ylittää 50 MB:n enimmäisrajan',
  attachmentView: 'Näytä Liitteet',
  attributions: 'Määritteet',
  august: 'Elokuu',
  autoHideEmptyCards: 'Piilota automaattisesti tyhjät kortit',
  autoHotpoint: 'Auto Hotpoint',
  autoPopulate: 'Täytä Automaattisesti',
  automaticZoom: 'Automaattinen Zoomi',
  availability: 'Saatavuus',
  back: 'Takaisin',
  backCover: 'Takakansi',
  backStitch: 'Takanidonta',
  backToLibrary: 'Takaisin Kirjastoon',
  backToSearch: 'Palaa Hakuun',
  badCredentials: 'Virheelliset Tunnukset',
  badDefaultValueMessage: 'Oletusarvon on oltava {min}–{max} merkkiä.',
  bahasaDescription: 'Bahasa Indonesia Kuvaus',
  bahasaName: 'Bahasa Indonesia Nimi',
  banner: 'Banneri',
  banners: 'Bannerit',
  barColor: 'Palkin väri',
  before: 'Ennen',
  beginTypingToFindAnything: 'Aloita kirjoittaminen etsiäksesi mitä tahansa',
  beta: 'Beta',
  betaAccessKeys: 'Beta Pääsyavaimet',
  betaReleaseVideo: 'Beta-Julkaisuvideo',
  betaResources: 'Beta-Resurssit',
  blobFinder: 'BLOB-haku',
  body: 'Teksti',
  bom: 'BOM',
  bomDefaultSupplier: 'BOM-oletustoimittaja',
  bomExportSuccess: 'BOM-vienti onnistui',
  bomItem: 'BOM Item',
  bomItems: 'BOM-nimikkeet',
  bomLayout: 'Materiaaliluettelon Asettelu',
  bomListOptions: 'BOM Luettelovaihtoehdot',
  bomListSettings: 'BOM Luetteloasetukset',
  book: 'Kirja | Kirjat',
  bookInserts: 'Kirjalisäykset',
  bookLabel: 'Kirja | Kirjat',
  bookPrintingDisable: 'Poista Kirjan Tulostus Käytöstä',
  booksAndPagesDisplay: 'Kirjojen ja Sivujen Näyttö',
  boost: 'Haun Tehostaminen',
  boostDescription: 'Lisäämällä suuremman arvon kuin 1,5 voit tehostaa tämän tagin haun osuvuutta osanumeroissa, mediatunnisteissa ja nimissä',
  boostRangeInvalid: 'Boostin on oltava välillä 0,5 ja 100,0',
  border: 'Reunaviiva',
  both: 'Molemmat',
  bottom: 'Alas',
  branding: 'Brändäys',
  browse: 'Selaa',
  browseComputer: 'Selaa Tietokonetta',
  browseFlow: 'Selausjärjestys | Selausjärjestykset',
  browseFlowAssigned: 'Selausjärjestys Kohdistettu',
  browseFlowCopyMessage: 'Anna uudelle Selausjärjestykselle yksilöllinen nimi.',
  browseFlowDeleteMessage: 'Selausjärjestyksen poistaminen ei poista vain selausjärjestystä vaan myös kaikki sen alatason selausjärjestykset.',
  browseFlowDeleted: 'Selausvirta poistettu',
  browseFlowEmptyState: 'Selausjärjestyksiä ei ole määritetty. {New}, niin pääset alkuun.',
  browseFlowHierarchy: 'Selausjärjestyksen Hierarkia',
  browseFlowMediaCategoryProductPageHelpText: 'Poista tällä hetkellä lisätty “Tyyppi: tuotesivu” -hakukriteeri ottaaksesi muutokset käyttöön',
  browseFlowMoveToRoot: 'Tee ensimmäinen alataso pudottamalla solmun tähän',
  browseFlowNoAssignedOrgs: 'Kohdistettuja organisaatioita ei ole',
  browseFlowNoExistingCriteria: 'Tälle selausjärjestykselle ei ole asetettu hakukriteerejä.  Valitse hakukriteerit yllä olevien asetusten avulla.',
  browseFlowNoExistingCriteriaBelow: 'Tälle selailuprosessille ei ole määritetty hakukriteerejä.  Käytä alla olevia ohjaimia valitaksesi hakukriteerit.',
  browseFlowSaveFailed: 'Selausjärjestyksen päivitys ei onnistunut',
  browseFlowSaved: 'Selausjärjestys tallennettu',
  browseFlowSelectionRequired: 'Selailuprosessin valinta on pakollinen.',
  browseFlowSetDefaultSuccess: 'Oletusselausjärjestys asetettu',
  browseFlowThumbnailDeleteFailTitle: 'Esikatselukuvan Poisto Epäonnistui',
  browseFlowThumbnailDeleteSuccessTitle: 'Esikatselukuvan Poisto Onnistui',
  browseFlowThumbnailUploadFailTitle: 'Esikatselukuvan Lataus Epäonnistui',
  browseFlowThumbnailUploadSuccessTitle: 'Esikatselukuvan Lataus Onnistui',
  browseFlowTooManyOrgs: 'Sinulla on liian monta organisaatiota nykyisen selausjärjestyksen editorin käyttämiseksi. Ota yhteyttä Documoton tukeen osoitteessa {email}, niin saat apua Documoton selausjärjestysten muokkaamiseen.',
  browserDeprecation: {
    text: 'Johtuen Microsoftin tuen päättymisestä Internet Explorerille (kaikki versiot) ja siihen liittyvistä tietoturvahuolista emme enää 30. syyskuuta 2021 alkaen tue käyttäjien pääsyä tälle sivustolle Internet Exploreria (kaikki versiot) käyttämällä.',
    title: 'Ilmoitus Selaimen Vanhentumisesta'
  },
  browserPartiallySupport: 'Voit nähdä tässä selaimessa ulkoisia eroja ja muita muutoksia.',
  buildHotpointLinks: 'Muodosta Kohdepistelinkkejä',
  buildHotpointLinksInfo: 'Tämä toiminto poistaa ensin kaikki olemassa olevat kohdepistelinkit kirjan sivuilta. Luo sitten uudet kohdepistelinkit osien ja vastaavien kokoonpanosivujen välille.',
  buildHotpointLinksTitle: 'Haluatko muodostaa kohdepistelinkkejä tähän kirjaan?',
  bulkApplyAllOrgs: 'Ota käyttöön samaan aikaan kaikille organisaatioille',
  bulkApplyAllOrgsModalMsg: 'Haluatko varmasti ottaa tämän sisällön käyttöoikeuden käyttöön kaikille organisaatioille? Napsauttamalla ”Vahvista” otat käyttöoikeuden käyttöön kaikille organisaatioille, ja käyttöoikeuksien muutokset tallennetaan.',
  bulkExportConfirm: 'Haluatko viedä {n} {unit}?',
  bulkExportLimit: 'Raja on {limit} kirjaa per vienti',
  bulkImport: 'Massatuonti',
  bulkIndexingLane: 'Joukon indeksointikaista',
  bulkInsert: 'Joukkolisäys',
  bulkPageInsertJob: 'Sivun Joukkolisäys',
  bulkRemoveAllOrgs: 'Poista samaan aikaan kaikista organisaatioista',
  bulkRemoveAllOrgsModalMsg: 'Haluatko varmasti poistaa tämän sisällön käyttöoikeuden käytöstä kaikista organisaatioista? Napsauttamalla ”Vahvista” poistat käyttöoikeuden käytöstä kaikista organisaatioista, ja käyttöoikeuksien muutokset tallennetaan.',
  business: 'Business',
  button: 'Painike',
  cameraSettings: 'Kamera-asetukset',
  cancel: 'Peruuta',
  cancelAssemblyCreatorSubtitle: 'Kokoonpanon luontia ei käsitellä.',
  cancelAssemblyCreatorTitle: 'Hylätäänkö kokoonpanon luonti?',
  canceled: 'Peruutettu',
  cannotExceed100: 'Ei voi ylittää 100 %',
  cannyWidgetLoadFailure: 'Palautefoorumin lataaminen epäonnistui',
  cart: 'Ostoskori | Ostoskorit',
  cartBehaviorDisabled: 'Poista Käytöstä Lisää Ostoskoriin Määrän Kehote',
  cartBehaviorEnabled: 'Ota Käyttöön Lisää Ostoskoriin Määrän Kehote',
  cartBehaviorLabel: 'Lisää Ostoskoriin Määrän Toiminta',
  cartColumn: 'Ostoskorisarake | Ostoskorisarakkeet',
  cartColumn1: '1. Ostoskorin Hintasarake',
  cartColumn2: '2. Ostoskorin Hintasarake',
  cartColumn3: '3. Ostoskorin Hintasarake',
  cartColumnPartLocationContent1: 'Tämän ominaisuuden käyttöön ottamisella on seuraavat vaikutukset:  ',
  cartColumnPartLocationContent2: 'Osan rivin yksilöllisyys ostoskorissa perustuu myös sen sijaintiin sisällössä, jos sovellettavissa.',
  cartColumnPartLocationContent3: 'Tätä asetusta ei voi poistaa käytöstä organisaation tasolla ja se koskee kaikkia käyttäjiä.',
  cartColumnPartLocationContent4: 'Tätä asetusta ei tule ottaa käyttöön yhdessä Lähetä ostoskori -integroinnin kanssa ottamatta ensin yhteyttä Documoton Customer Success Manageriin.',
  cartColumnPartLocationOption: 'Ota Osan Sijaintitiedot Käyttöön Ostoskorissa',
  cartColumnPartLocationTitle: 'Oletko varma, että haluat ottaa Osan Sijaintietiedot Käyttöön Ostoskorissa?',
  cartDisable: 'Poista Ostoskori Käytöstä',
  cartEmailFailed: 'Ostoskorin sähköpostiviesti epäonnistui',
  cartEmailSent: 'Ostoskorin sähköpostiviesti lähetetty',
  cartEnable: 'Ota Ostoskori Käyttöön',
  cartErpMessage: 'Lähetys Erp:iin Onnistui',
  cartImportError: 'Virhe ostoskorin tuonnissa',
  cartLoadedWithItemsRemoved: '{count} kohdetta poistettu, koska sinulla ei ole oikeutta tilata niitä tällä hetkellä',
  cartSaveEnable: 'Ota Ostoskorin Tallennus Käyttöön',
  cartSharedAddEdit: 'Lisää / Muokkaa Jaettuja Ostoskoreja',
  cartUpdated: 'Ostoskärry päivitetty',
  cartUpdatedAndRemovedCount: 'Ostoskori Päivitetty; {count} ei-tilattavissa olevaa osaa poistettu',
  category: 'Kategoria | Kategoriat',
  categoryCreated: 'Kategoria Luotu',
  categoryNotFoundError: '403: Kokonaisuuskategoriaa ei löydy',
  categoryUpdated: 'Kategoria Päivitetty',
  centimeter: 'Senttimetri | Senttimetrit',
  changeNotification: 'Muuta Ilmoitusta',
  changeScope: '{n} {type} on kohteena',
  changeUserOrganization: 'Vaihda Organisaatio',
  chapter: 'Kappale | Kappaleet',
  chapterHeader: 'Kappaleen Ylätunniste',
  chaptersOnly: 'Vain kappaleet',
  charLimitHelpText: 'Syötä {min}–{max} merkkiä',
  chineseDescription: 'Kiina Kuvaus',
  chineseName: 'Kiina Nimi',
  circle: 'Ympyrä',
  city: 'Kaupunki',
  className: 'Luokan nimi',
  classicAdminMessage: 'Tämä ohjaa sinut takaisin Flexiin käyttämään hallintamoduuleja.',
  classicAdmins: 'Perinteinen Hallinta',
  classicExporter: 'Perinteinen Vientitoiminto',
  classicExporterMessage: 'Vanha Flash-pohjainen sisällön vientimoduuli',
  classicOrganizationAdmin: 'Perinteinen Organisaation Hallintatoiminto',
  classicOrganizationAdminMessage: 'Vanha Flash-pohjainen käyttäjien hallintamoduuli organisaatioiden ja käyttäjien hallintaan',
  classicPublisher: 'Perinteinen Julkaisutoiminto',
  classicPublisherMessage: 'Vanha Flash-pohjainen julkaisumoduuli sisällön luontia ja tulostusasetuksia varten',
  classicReporting: 'Perinteinen Raportointitoiminto',
  classicReportingMessage: 'Vanha Flash-pohjainen raportointimoduuli',
  classicTenantAdmin: 'Perinteinen VTenant-Hallintatoiminto',
  classicTenantAdminMessage: 'Vanha Flash-pohjainen hallintamoduuli tenant-asetuksia varten',
  clear: 'Tyhjennä',
  clearFilters: 'Tyhjennä Suodattimet',
  clearHotpoints: 'Tyhjennä hotpointit',
  clearItemNumber: 'Tyhjennä tuotenumero',
  clearItemNumberMessage: 'Tuotenumeron poistaminen poistaa myös seuraavat tiedot:',
  clearItemNumberTitle: 'Haluatko tyhjentää tuotenumeron?',
  clearSearch: 'Tyhjennä haku',
  clickAction: 'Napsauta Toimenpide',
  clickHereToUpload: 'Pudota tiedosto tai napsauta ladataksesi korvaava.',
  clickMagnifyingGlass: 'Napsauta suurennuslasia mennäksesi suoraan Edistyneeseen hakuun.',
  clickOkToContinue: 'Jatka napsauttamalla ”OK”. ',
  clickToDownload: 'Napsauta Ladataksesi',
  clickToEnlarge: 'Napsauta suurentaaksesi',
  clickToOpen: 'Napsauta Avataksesi',
  clipboard: 'Leikepöytä',
  clipboardAccessError: 'Muokkaa selainasetuksesi sallimaan Leikepöydän käyttö',
  close: 'Sulje',
  closed: 'Suljettu',
  collapseAll: 'Tiivistä Kaikki',
  color: 'Väri | Värit',
  column: 'Sarake | Sarakkeita',
  columnItemType: {
    customText: 'Mukauta Teksti',
    documentTitle: 'Asiakirjan Otsikko',
    horizontalLine: 'Vaakaviiva',
    pageName: 'Sivun Nimi',
    pageNumber: 'Sivun Numero',
    printDate: 'Tulostuspäivämäärä',
    tenantName: 'Tenant-Nimi',
    userName: 'Käyttäjän Nimi'
  },
  columnMapping: 'Sarakkeiden kartoitus',
  columnName: 'Sarakkeen Nimi',
  combinedPage: 'Yhdistetty Sivu',
  combinedPageMessage: 'Kaavio ylhäällä, osaluettelo alhaalla',
  comingSoon: 'Tulossa Pian',
  commaDelimited: 'Pilkulla erotettu',
  comment: 'Kommentti | Kommentit',
  commentAdded: 'Kommentti lisätty',
  commentCannotBeEmpty: 'Kommentti ei voi olla tyhjä',
  commentDeleted: 'Kommentti poistettu',
  commentEdit: 'Lisää / Muokkaa kommentteja',
  commentEditAll: 'Muokkaa Kaikkia Kommentteja',
  commentUpdated: 'Kommentti päivitetty',
  commentView: 'Näytä Kommentit',
  commerceSystem: 'Kaupankäyntijärjestelmä',
  completed: 'Valmis',
  configuration: 'Kokoonpano | Kokoonpanot',
  confirm: 'Vahvista',
  confirmBrowseFlowApplyToChildren: 'Haluatko käyttää tätä selausjärjestystä alaorganisaatioissa?',
  confirmBrowseFlowOverrideToChildren: 'Tämä poistaa kaikki alaorganisaatioissa asetetut selausjärjestysten ohitukset.',
  confirmPrintSettingsApplyToChildren: 'Haluatko käyttää tätä tulostusasetusta alaorganisaatioissa?',
  confirmPrintSettingsOverrideToChildren: 'Tämä poistaa kaikki alaorganisaatioissa asetetut tulostusasetusten ohitukset.',
  contains: 'Sisältää',
  containsHeaderRow: 'Sisältää Ylätunnisterivin',
  content: 'Sisältö | Sisällöt',
  contentAccessControls: 'Kohteen {content} Käyttöoikeudet',
  contentEntity: 'Sisältökokonaisuus | Sisältökokonaisuudet',
  contentNotFound: 'Sisältöä ei löydy',
  contentUpdatedQueueJob: 'Sisältö Päivitetty Jono',
  contentViewerMoreInfo: 'Lisätiedot',
  contourShape: 'Ääriviivan muoto',
  convertEntity: 'Muunna {entity}',
  convertToEntity: 'Muunna kohteeksi {entity}',
  copiedPartNumber: 'Kopioitu osanumero {partNumber}',
  copy: 'Kopioi',
  copyAccessControls: 'Kopioi Käyttöoikeudet',
  copyAccessControlsWarning: 'Tämä kopioi kaikki kohdistetut käyttöoikeudet valitusta Organisaatiosta tähän Organisaatioon',
  copyAndRetain: 'Kopioi ja Säilytä Integrointia varten',
  copyAndRetainWidget: 'Kopioi ja säilytä, tämä on ainoa kerta, kun widgetin valtuutusarvo näkyy sovelluksessa',
  copyAtoB: 'Kopioi {a} kohteeseen {b}',
  copyBranches: 'Kopioi haarat',
  copyBranchesMessage: 'Kopioi valitut haarat lähdeselailuprosessista kohdeselailuprosessiin.',
  copyContent: 'Kopioi {type}? {name}',
  copyItem: 'Kopioi {item}',
  copyItemQuestion: 'Kopioidaanko {item}?',
  copyMeMessage: 'Kopioi minut tähän viestiin',
  copyPartNumberToClipboard: 'Kopioi {label} leikepöydälle',
  copyProduct: 'Kopioi tuote',
  copyTo: 'Kopioi kohteeseen {target}',
  copyingItem: 'Kopioidaan {item}',
  copyrightMessage: '© 2010-{year} Documoto Inc. Kaikki oikeudet pidätetään.',
  count: 'Määrä',
  country: 'Maa | Maat',
  coverAmpStitchPages: 'Kansi- ja Nidontasivut',
  coverPages: 'Kansisivut',
  createAssembly: 'Luo Kokoonpano',
  createNewProductPage: 'Luo uusi tuotesivu',
  created: 'Luotu',
  createdBy: 'Luonnin suoritti {name}',
  createdDate: 'Luontipäivä',
  createdOn: 'Luotu',
  currentPassword: 'Nykyinen Salasana',
  custom: 'Mukautettu',
  czechDescription: 'Tsekki Kuvaus',
  czechName: 'Tsekki Nimi',
  dashboard: 'Koontinäyttö | Koontinäytöt',
  dashboardLibrary: 'Ohjauspaneelin kirjasto',
  dataInsights: 'Tietojen oivallus',
  dataInsightsInfoMessage: 'Sisällön, käyttäjän ja kirjaston tietojen oivalluksen raportointi- ja ohjauspaneelikeskus.',
  dataMapping: 'Tietokartoitus/Näytedata (enintään 10 riviä)',
  dataOptions: 'Tietoasetukset',
  date: 'Päivämäärä',
  dateModified: 'Muokkauspäivä',
  debugPageBuilderPLZ: 'Debug Sivunrakentaja PLZ',
  december: 'Joulukuu',
  decreaseHotpoint: 'Vähennä Hotpoint',
  'default': 'Oletus',
  defaultAddress: 'Oletusosoite',
  defaultBrowseFlow: 'Oletusselausjärjestys',
  defaultCurrencyCode: 'Oletusvaluutan Koodi',
  defaultCurrencySymbolOn: 'Oletusvaluuttasymboli päällä',
  defaultEmailRecipient: 'Sähköpostin Oletusvastaanottaja | Sähköpostin Oletusvastaanottajat',
  defaultImage: 'Oletuskuva | Oletuskuvat',
  defaultImagesManager: 'Oletuskuvien Hallintatoiminto',
  defaultItemImage: 'Kohteen {item} Oletuskuva',
  defaultPartsListLayout: 'Osaluettelon Oletusasettelu',
  defaultPartsListLayoutHelp: 'Osien oletusasettelu kuvituksen vasemmalle puolelle tai alle',
  defaultSearchMode: 'Oletushakutila',
  defaultSearchModeHelp: 'Yleinen oletushakumenetelmä kohtaan \'sisältää\' tai \'tarkka\'',
  defaultSortMode: 'Oletushakutila',
  defaultSupplier: 'Oletustoimittaja',
  defaultTocStateOpen: 'Sisällysluettelo Oletusarvoisesti Auki',
  defaultTocStateOpenHelp: 'Määrittää, avautuuko Sisällysluettelo automaattisesti kirjaa katseltaessa',
  defaultUom: 'Oletus UOM',
  defaultValue: 'Oletusarvo',
  defaultView: 'Oletusnäkymä',
  defaults: 'Oletusarvot',
  defaultsAndCapabilities: 'Oletusarvot ja Ominaisuudet',
  'delete': 'Poista',
  deleteAll: 'Peri Ylätasolta',
  deleteAnyPartnerApiKeys: 'Poista mikä tahansa kumppanin API-avain, joka annettiin SmartEquipille.',
  deleteContent: 'Oletko varma, että haluat poistaa kohteen {type}? {name}',
  deleteFilesMessage: 'Oletko varma, että haluat poistaa {count} tiedoston(tiedostot)?',
  deleteHotpointLinksTitle: ' Haluatko varmasti poistaa pikalinkin/-linkit?',
  deleteMessage: 'Haluatko varmasti poistaa?',
  deletePart: {
    affectedCarts: 'Kaikki ostoskorit, jotka sisältävät tämän osan, poistetaan pysyvästi.',
    deletingPartNumber: '{partNumber} poistetaan.',
    infoOne: 'Osien poistot tulevat voimaan välittömästi kirjaston ja sisällön hallinnassa. Poistettu osa pysyy hakukelpoisena, kunnes indeksointi on tehty uudelleen muutaman minuutin kuluessa.',
    infoTwo: 'Tätä toimenpidettä ei voi perua ilman Documoto-tuen apua. Poistettu tietue ja kaikki yhteydet poistetaan pysyvästi 90 päivän kuluttua.'
  },
  deletePartCollectionConfirmMsg: 'Haluatko varmasti poistaa tämän kohteen {partCollection} kohteesta {productPage}?',
  deletePartInUse: {
    body: 'Documoto tukee tällä hetkellä vain sellaisten osien poistamista, jotka eivät kuulu sivuille. Poista tämä osa kaikista julkaistuista tai luonnossivuista, jotta voit jatkaa poistamista.',
    submitLabel: 'Siirry sivulle, jossa käytetään',
    title: 'Tämä osa kuuluu sivulle (sivuille) eikä sitä voi poistaa.'
  },
  deleteProductPage: {
    deletingIdentifier: '{identifier} poistetaan.',
    infoOne: 'Tuotesivujen poistot tulevat voimaan välittömästi kirjaston ja sisällön hallinnassa. Poistettu tuotesivu pysyy hakukelpoisena, kunnes indeksointi on suoritettu uudelleen muutaman minuutin kuluessa.',
    infoTwo: 'Tätä toimenpidettä ei voi perua ilman Documoto-tuen apua. Poistettu tietue ja kaikki assosiaatiot poistetaan pysyvästi 90 päivän kuluttua.'
  },
  deleteRelated: 'Haluatko varmasti poistaa {count} {type}?',
  deleteSelectedCriteria: 'Poista Valitut Kriteerit',
  deleteTagsTitle: 'Haluatko varmasti poistaa tunnisteen (tunnisteet)?',
  deleteTaxonMessage: 'Tämä poistaa pysyvästi tämän luokan ja kaikki sen alatasot. Haluatko varmasti jatkaa?',
  deleteTaxonomyMessage: 'Tämä poistaa pysyvästi kaikki tämän Organisaation tai Tenant-luokat. Haluatko varmasti jatkaa?',
  deleteTenantSupplier: 'Haluatko varmasti poistaa tämän toimittajan vuokraajalle?',
  deletedItem: '{item} poistettu',
  demo: 'Demo',
  description: 'Kuvaus',
  deselectAll: 'Poista Kaikkien Valinta',
  deselectCriteria: 'Poista Kriteerien Valinta',
  detail: 'Yksityiskohta | Yksityiskohdat',
  diagonal: 'Diagonaalinen',
  diameter: 'Halkaisija',
  disable: 'Poista Käytöstä',
  disableAll: 'Poista kaikki käytöstä',
  disableDocumotoTenant: 'Poista Documoto-vuokralainen käytöstä',
  disableFwdReindex: 'Poista käytöstä edelleen toimitettu uudelleen indeksoitu kohdemedia DSW:lle',
  disableLibraryBannerImage: 'Poista kirjaston bannerikuva käytöstä',
  disableSmartEquipModalTitle: 'Haluatko varmasti poistaa tämän lisenssin käytöstä?',
  disableTEK: 'Poista suora URL-kirjautuminen käytöstä',
  disableUserLogin: 'Ota käyttäjätunnus-/salasanakirjautuminen pois käytöstä',
  disableUserLoginErrorMessage: 'Organisaatiosi vaatii SSO-tunnistautumisen. Käyttäjätunnus-/salasanakirjautuminen ei ole sallittu käyttäjäryhmällesi. Kirjaudu sisään käyttämällä SSO-tunnistautumista.',
  disableUserLoginTooltip: 'Tämän ottaminen käyttöön vaatii toimivan SSO-määritelmän. Jos SSO-tunnistautumista ei ole määritetty, kyseiset käyttäjät menettävät pääsyn Documotoon.',
  disabled: 'Poistettu Käytöstä',
  discard: 'Hylkää',
  discardChanges: 'Hylkää Muutokset',
  discardQ: 'Hylkää Muutokset?',
  discountPrice: 'Alennushinta',
  discounted: 'Alennettu',
  discountedPrice: 'Alennettu Hinta',
  discountedTotal: 'Alennettu Yhteensä',
  displayInOrdersList: 'Näytä Tilausluettelossa',
  displayLocation: 'Näytä sijainti',
  displayOrder: 'Näyttöjärjestys',
  displayOrderDescription: 'Asettaa Suodattimien pudotusvalikon näyttöjärjestyksen sisältötyyppien tageille',
  displaySupplierPartInfo: 'Näytä toimittaja osatiedoissa',
  document: 'Asiakirja | Asiakirjat',
  documentLabel: 'Asiakirja | Asiakirjat',
  documentSettings: 'Asiakirjan asetukset',
  documotoAcademy: 'Documoto Academy',
  documotoLicensePackage: 'Documoto-lisenssipaketti',
  domain: 'Domain',
  domainEmptyMessage: 'Sallittu domain ei voi olla tyhjä',
  domainInvalidMessage: 'Voimassaoleva domain on pakollinen',
  download: 'Lataa',
  downloadBrowser: 'Lataa yksi näistä erinomaisista selaimista.',
  downloadFailed: 'Virhe ladattaessa {name}',
  downloadStarted: 'Lataus on käynnissä {name}',
  draft: 'Luonnos | Luonnokset',
  draftBomDeleteTitle: 'Haluatko varmasti poistaa tämän osan sivulta?',
  draftBomDropError: 'Osia ei voi sijoittaa sisäkkäin yli 5 tasoa syvemmälle',
  draftBomEmptyField: 'Kaikki osaluettelon kentät on täytettävä',
  draftBomError: 'Virhe materiaaliluonnoksen käsittelyssä',
  draftBomMultipleDeleteTitle: 'Haluatko varmasti poistaa nämä osat sivulta?',
  draftBomQuantityError: 'Määrän on oltava numero',
  draftPage: 'Luonnossivu',
  draftPageDelete: 'Poista luonnos',
  draftPageDeleteMessage: 'Luonnossivu poistettu onnistuneesti.',
  draftPageDeleteWarning: 'Sivun luonnoksen poistaminen poistaa meneillään olevat päivitykset.',
  draftPageLastUpdated: 'Luonnos - viimeksi päivitetty {date} käyttäjältä {username}',
  draftPageLoadError: 'Luonnossivun lataaminen epäonnistui.',
  draftPageProcessingPlz: 'Sivua ladataan PLZ-tiedostosta',
  draftPagePublishInProgress: 'Sivun julkaisutyö käynnissä',
  draftPageSaveSuccess: 'Luonnossivu tallennettu onnistuneesti.',
  draftPageSaveUnsuccessful: 'Luonnossivun tallennus epäonnistui.',
  draftSheetImageHotpointsFailure: 'Algoritmin {algorithm} hotpointeja ei voi muodostaa luonnoskuvalle.',
  draftValidationMessage: {
    empty: 'Ei Validointivirheitä/Varoituksia',
    hotpointOrHotpointLink: 'BOM-kohteelle {item} ei ole määritetty hotpointia(-eja)/hotpoint-linkkiä(-ejä)',
    item: 'VAROITUS: BOM-osanumerolle {partNumber} ei ole määritelty Tuotenumeroa',
    quantity: 'BOM-kohteelle {item} ei ole määritetty määrää',
    supersede: 'Osa {partNumber} korvasi osan {supersededPartNumber} ylityksen vuoksi.',
    tag: 'BOM-kohteen {item} merkistä {tagName} puuttuu merkkiarvo',
    translationDescription: 'BOM-kohteesta {item} puuttuu {lang} käännöskuvaus',
    uom: 'BOM-kohteelle {item} ei ole määritetty mittayksikköä'
  },
  drawAutohotpointRegion: 'Piirrä {shape} koko',
  drawMinimumArea: 'Piirrä minimialue',
  dropFileMessage: 'Pudota tiedosto tähän tai napsauta ladataksesi.',
  duplicate: 'Kopioi',
  duplicateSaveError: 'Merkintä on päällekkäinen. Ei voida tallentaa.',
  dutchDescription: 'Hollanti Kuvaus',
  dutchName: 'Hollanti Nimi',
  dynamic: 'Dynaaminen',
  dynamicNaming: 'Dynaaminen Nimeäminen',
  ecommerce: 'Sähköinen kaupankäynti',
  ecommerceEmailFormatCreated: 'Verkkokaupan sähköpostimuoto luotu',
  ecommerceEmailFormatSaved: 'Verkkokaupan sähköpostimuoto tallennettu',
  ecommerceLogo: 'Verkkokaupan logo',
  ecommerceUseExtOrder: 'Verkkokaupan käytön ulkoinen tilausnumero',
  edit: 'Muokkaa',
  editItem: 'Muokkaa kohdetta {item}',
  email: 'Sähköposti',
  emailAsCsv: 'Lähetä sähköpostitse CSV-muodossa (Pakollinen Muoto Tuonnissa)',
  emailAsXlsx: 'Lähetä sähköpostitse XLSX-muodossa',
  emailBasicPartInfo: 'Lähetä sähköpostitse Osan Perustiedot',
  emailComments: 'Sähköpostin kommentit',
  emailDetails: 'Sähköpostin yksityiskohdat',
  emailDisplayedCartColumns: 'Sähköpostin näytetyt ostoskorisarakkeet',
  emailFormat: 'Sähköpostimuoto',
  emailFormatTemplate: 'Sähköpostimuodon malli | Sähköpostimuotojen mallit',
  emailList: 'Sähköpostiluettelo',
  emailMessage: 'Sähköposti on pakollinen',
  emailRecipient: 'Sähköpostin Vastaanottaja | Sähköpostin Vastaanottajat',
  emailRecipientMessage: 'Nämä sähköpostiosoitteet saavat sähköpostia, kun tilauksen tila muuttuu tilaksi',
  emailSubject: 'Sähköpostin otsikko',
  emptyBomState: 'Sivulle ei ole määritelty BOM-kohteita. Klikkaa +{add} aloittaaksesi',
  emptyMessage: {
    orderSuggestions: 'Näyttää siltä, että tälle osalle ei ole vielä Tilausehdotuksia.'
  },
  enable: 'Ota Käyttöön',
  enable3d: 'Ota 3D käyttöön',
  enable3dIllustrations: 'Ota 3D-kuvitukset käyttöön',
  enable3dThumbnails: 'Ota 3D-pienkuvakkeet käyttöön',
  enableAPIKeyAdmin: 'Ota käyttöön API-avaimen ylläpito',
  enableAll: 'Ota kaikki käyttöön',
  enableCommerce: 'Ota Kaupankäynti Käyttöön',
  enableEcommerceOrderManagement: 'Ota käyttöön tilaushallinta',
  enableExportToLinkOne: 'Ota käyttöön vienti LinkOneen',
  enableExportToSmartEquip: 'Ota käyttöön vienti SmartEquipiin',
  enableExporter: 'Ota käyttöön vientitoiminto',
  enableIframeSupport: 'Ota käyttöön iFrame-tuki',
  enableKnowledgeBase: 'Ota käyttöön tekoälypohjainen haku',
  enableLibraryBetaFeatures: 'Ota kirjaston beta-ominaisuudet käyttöön',
  enableMediaCategorySearch: 'Ota käyttöön ryhmittely mediakategorioiden mukaan kontekstuaalisessa haussa',
  enablePDFDownloadWarning: 'Ota käyttöön suuren PDF:n latausvaroitus',
  enablePLZToDraft: 'Ota käyttöön PLZ-käsittely luonnokseksi',
  enablePerformanceLogging: 'Ota käyttöön suorituskyvyn kirjaus',
  enableQuickAddToCart: 'Ota käyttöön pikalisäys ostokoriiin',
  enableQuickAddToCartHelpContext: 'Asetus arvoon ’Ota käyttöön’ ottaa käyttöön pikalisäyksen ostoskoriin -ominaisuuden sisällönkatseluohjelman yläpuolelle tälle sisällölle.',
  enableRocketUi: 'Ota Rocket-Käyttäjäkokemus Käyttöön',
  enableSmartEquipApiIntegration: 'Ota käyttöön SmartEquip API -integraatio',
  enableWidgetLogo: 'Ota käyttöön Documoto Widget -logo',
  enableWidgets: 'Ota widgetit käyttöön',
  enabled: 'Otettu käyttöön',
  encryptedKey: 'Salattu Avain',
  endDate: 'Päättymispäivä',
  endDateBad: 'Aloituspäivämäärän on oltava sama tai aikaisempi kuin päättymispäivämäärä.',
  enforceNumericSize: 'Pakota Numeerinen Koko',
  englishDescription: 'Englanti Kuvaus',
  englishName: 'Englanti Nimi',
  enterReportParameters: 'Raportin parametrien lisääminen',
  enterUniqueNameForNewItem: 'Anna tälle uudelle kohteelle {item} yksilöllinen nimi',
  enterValidEmail: 'Anna kelvollinen sähköposti',
  enterValidNumber: 'Anna kelvollinen numero',
  enterprise: 'Yritys',
  entityType: 'Kokonaisuustyyppi | Kokonaisuustyypit',
  erp: 'ERP',
  erpEndpointConfig: 'ERP-päätepisteen konfigurointi',
  erpPartInfo: 'ERP-osan tiedot välimuistin kesto minuuteissa',
  erpSystem: 'ERP-Järjestelmä',
  erpSystemSaved: 'ERP-järjestelmä tallennettu',
  erpSystems: 'ERP-järjestelmät',
  error: 'Virhe',
  errorDeletePageMessage: 'Sivua poistettaessa tapahtui virhe.',
  errorInputParsing: 'Ongelma jäsennettäessä syötetiedostoa.',
  errorPageMessage: 'Tapahtui virhe.',
  errorPageTitle: 'Jotakin meni vikaan...',
  errorType: {
    error: 'Virhe',
    warning: 'Varoitus'
  },
  essential: 'Essential | Essentials',
  eta: 'ETA',
  etlJob: 'ETL',
  exact: 'Tarkka',
  excelFile: 'Excel-tiedosto',
  existing: 'Olemassa oleva',
  expandAll: 'Laajenna Kaikki',
  'export': 'Vie',
  exportAsCSVDropdown: 'Vie CSV-muodossa',
  exportAsCsv: 'Vie CSV-muodossa (Pakollinen Muoto Tuonnissa)',
  exportAsHtml: 'Vie HTML-muodossa',
  exportAsPdf: 'Vie PDF-muodossa',
  exportAsPlz: 'Vie PLZ-muodossa',
  exportAsXlsx: 'Vie XLSX-muodossa',
  exportBasicPartInfo: 'Vie Osan Perustiedot',
  exportCartToXlsxDisabled: 'Poista Käytöstä Ostoskorin Vienti XLSX:ään',
  exportCartToXlsxEnabled: 'Ota Käyttöön Ostoskorin Vienti XLSX:ään',
  exportDisplayedCartColumns: 'Vie Näytetyt Ostoskorisarakkeet',
  exportJob: 'Vientityö',
  exportLane: 'Vie kaista',
  exportMessage: 'Vientityön lähetys onnistui.',
  exportParts: 'Vie Osat',
  exportPartsXlsx: 'Vie osat XLSX-tiedostoon',
  exportSearch: 'Vientihaku',
  exporter: 'Vientitoiminto',
  exporterMessage: 'Sallii sinun viedä sisältöä',
  external: 'Ulkoinen | Ulkoiset',
  externalUrl: 'Ulkoinen URL',
  faceted: 'Kuvioitu',
  facetedTag: 'Suodatinarvojen tulee olla kohdistettuja',
  facetedTagTooMany: 'Tagi ylittää 1000 yksilöllisen tagin rajan',
  failedAction: 'Kohdetta {content} ei voitu {action}.',
  failedProcessContentSql: 'Sisällön käsittely epäonnistui luvattoman tekstin vuoksi. Lataa tuettu sisältö uudelleen.',
  failedToCopy: 'Kohteen {content} kopiointi epäonnistui.',
  failedToDelete: 'Kohdetta {content} ei voitu poistaa.',
  failedToLoad: 'Kohdetta {content} ei voitu ladata.',
  failedToSave: 'Kohdetta {content} ei voitu tallentaa.',
  failedToSubmitFeedback: 'Palautteen lähettäminen epäonnistui.',
  failedToSubmitItem: '{item} lähettäminen epäonnistui',
  failedToUpdate: 'Kohteen {content} päivitys epäonnistui.',
  'false': 'Väärin',
  faq: 'Usein Kysytyt Kysymykset',
  favorites: 'Suosikkikirjat',
  favoritesLists: 'Suosikkikirjaluettelo',
  february: 'Helmikuu',
  feedbackForm: 'Lähetä Palautetta',
  feedbackFormMessage: 'Kerro, mitä haluat nähdä',
  field: 'Kenttä | Kentät',
  fieldDefinition: 'Kentän Määrittely',
  fieldName: 'Kentän nimi',
  file: 'Tiedosto | Tiedostot',
  fileUpload: 'Tiedoston lataus',
  filename: 'Tiedostonimi',
  filesSubmitted: 'Tiedosto(t) lähetetty käsiteltäväksi',
  fill: 'Täytä',
  filter: 'Suodatin | Suodattimet',
  filterBoundsError: 'Suodattimessa on oltava vähintään 3 merkkiä',
  filterBy: 'Suodatustapa',
  filterOrgNameOnly: 'Suodatin: Vain Alkup. Nimi',
  filterOrgParentNames: 'Suodatin: Alkup. ja Vanhempien Nimet',
  filterable: 'Suodatettava',
  filterableTag: 'Suodatettavissa Oleva Tagi',
  finnishDescription: 'Suomi Kuvaus',
  finnishName: 'Suomi Nimi',
  firstName: 'Etunimi',
  firstNameEmpty: 'Etunimi ei voi olla tyhjä',
  fixedHotpointSize: 'Kiinteä Kohdepisteen Koko',
  font: 'Fontti | Fontit',
  footer: 'Alatunniste',
  forSearchTerm: 'hakusanalle {term}',
  forgotPassword: 'Unohditko Salasanasi',
  forgotPasswordMessage: 'Lähetämme antamallesi käyttäjätunnukselle sähköpostia, joka sisältää ohjeet salasanan palauttamiseksi.',
  forgotPasswordSuccess: 'Jos antamasi käyttäjätunnus on kelvollinen, lähetämme tiedostossa olevana sähköpostiin ohjeet salasanan palauttamiseksi.',
  form: 'Lomake | Lomakkeet',
  formCount: 'Lomakkeiden Määrä',
  formName: 'Lomakkeen nimi',
  formType: 'Lomakkeen tyyppi',
  format: 'Muoto',
  formattingOptions: 'Muotoiluasetukset',
  freezeImage: 'Lukitse kuva',
  frenchDescription: 'Ranska Kuvaus',
  frenchName: 'Ranska Nimi',
  fri: 'Pe',
  from: 'Lähettäjä',
  fromDate: 'Alkamispäivä',
  frontCover: 'Etukansi',
  frontStitch: 'Etunidonta',
  fullScreen: 'Koko näyttö',
  gdprFaqs: 'Yleistä Tietosuoja-asetusta (GDPR) Koskevat Usein Kysytyt Kysymykset',
  gdprMessage: 'Kirjautumalla tähän sivustomme osioon ymmärrät, että käytämme välttämättömiä evästeitä. Nämä evästeet ovat välttämättömiä palveluissamme navigoimiseen. Emme voi tarjota pyytämiäsi palveluita ilman kyseisiä evästeitä. Lisätietoja näet kohdassa {policy}.',
  general: 'Yleistä',
  generalSearch: 'Yleinen Haku',
  generalSearchCriteriaAlreadySet: '“Yleinen haku” -hakukriteeri on jo määritetty.',
  generic: 'Yleinen',
  germanDescription: 'Saksa Kuvaus',
  germanName: 'Saksa Nimi',
  goTo: 'Mene kohtaan',
  goToHome: 'Mene Etusivulle',
  goToJobManager: 'Mene Job Manageriin',
  goToPartCollections: 'Siirry kohteeseen {partCollections}',
  goToSearch: 'Mene Hakuun',
  gotIt: 'Selvä',
  hashKey: 'Ristikkonäppäin',
  header: 'Ylätunniste',
  headerAmpFooter: 'Ylä- ja Alatunniste',
  help: 'Ohjeet',
  helpCenter: 'Ohjekeskus',
  hideBookInSearchAndRecent: 'Piilota Kirjat Hakutuloksissa ja Viimeksi Lisätyissä',
  hideDuplicatePages: 'Piilota Sivujen Kaksoissivut',
  hidePageInSearchAndRecent: 'Piilota Sivut Hakutuloksissa ja Viimeksi Lisätyissä',
  hidePartInSearchAndRecent: 'Piilota Osat Hakutuloksissa ja Viimeksi Lisätyissä',
  highlightDescription: 'Korosta osia osaluettelossa tällä tagilla',
  history: 'Historia',
  home: 'Etusivu',
  homePageSettings: 'Etusivun asetukset',
  homepageOnly: 'Vain etusivu',
  horizontal: 'Horisontaalinen',
  host: 'Isäntä',
  hotpoint: 'Kohdepiste | Kohdepisteet',
  hotpointCalloutBehavior: 'Kiintopisteen hälytystoiminto',
  hotpointLink: 'Pikalinkki | Pikalinkit',
  hotpointLinksWillBeCreated: 'Kohdepistelinkit luodaan: ({count} {content})',
  hotpointShift: 'Hotpoint (Shift H)',
  hotpointZoomBehavior: 'Kiintopisteen zoomaustoiminto',
  hotpointsGenerated: 'Kuvasta löytyi {count} toimintopistettä.',
  hourlyDWSRequestLimit: 'Tuntikohtainen DWS-pyyntörajoitus',
  hourlyRESTRequestLimit: 'Tuntikohtainen REST-pyyntörajoitus',
  htmlUiUserSwitchEnabled: 'HTML UI -käyttäjäkytkin otettu käyttöön',
  hungarianDescription: 'Unkari Kuvaus',
  hungarianName: 'Unkari Nimi',
  icon: 'Kuvake',
  id: 'TUNNISTE',
  identifier: 'Tunniste',
  identifierRequiredErrorMessage: 'Tunniste on pakollinen',
  ignore: 'OHITA',
  ignoreAccessControls: 'Ohita Käyttöoikeudet',
  ignoreMatchingTranslations: 'Jätä huomiotta käännökset, joilla on yhteensopivat tapahtumapaikat tuonnissa',
  illustration: 'Kuvitus | Kuvitukset',
  image: 'Kuva | Kuvat',
  imageDeleteMessage: 'Haluatko varmasti poistaa tämän sivun kuvan?',
  imageDimensionsExceededMessage: 'Documoton suurin kuvakoko on 65,5 megapikseliä (8,191 X 8,191 pikseliä).  Kuva, jota yrität ladata, on ylittänyt enimmäismäärän, eikä sitä voi ladata. Napsauta "Muuta kokoa" antaaksesi Documoton muuttaa kokoa ja lisätä kuvan, tai "Peruuta" muokata kuvaa ja lisätä manuaalisesti',
  imageOptimizer: 'Kuvan Optimoija',
  imageSaveFail: 'Kuvan Tallennus Epäonnistui',
  imageSaveSuccess: 'Kuvien päivittäminen onnistui',
  imageSizeExceededMessage: 'Suurin Dokumotossa sallittu kuvatiedoston koko on {size} megatavua. Kuva, jota yrität ladata, on liian suuri eikä sitä voi ladata. Muuta kuvan kokoa lisätäksesi sen tälle sivulle.',
  imageSizeExceededTitle: 'Kuvan enimmäiskoko ylitetty',
  imageUploadFailure: 'Kuvan Lataus Epäonnistui',
  'import': 'Tuo',
  importBOM: 'Tuo BOM',
  importBOMError: 'Näytedatan käsittely epäonnistui, tarkasta syötelähde',
  importName: 'Tuonnin nimi',
  importParts: 'Tuo Osat',
  inCart: 'Ostoskorissa',
  inCartDescription: 'Näytä tagit ostoskorissa',
  inPartsList: 'Osaluettelossa',
  inPartsListDescription: 'Näytä tagit osaluettelossa',
  inch: 'Tuuma | Tuumat',
  includeComments: 'Sisällytä Kommentit',
  includeCommentsAuthorAndDate: 'Sisällytä Kommentin Antaja ja Päivämäärä',
  includeHeaderRow: 'Sisällytä otsikkorivi',
  includeImages: 'Sisällytä Kuvat',
  includeNewParts: 'Sisällytä vain "uudet" osat (ei Documotossa)',
  includePagePartDetails: 'Sisällytä sivun osien tason tiedot',
  includePagesIndex: 'Sisällytä Sivuhakemisto',
  includePartDetails: 'Sisällytä osien tason tiedot',
  includePartsIndex: 'Sisällytä Osahakemisto',
  includePartsList: 'Sisällytä Osaluettelo',
  includeSubChapters: 'Sisällytä Alikappaleet',
  includeWatermark: 'Lisää vesileima?',
  increaseHotpoint: 'Suurenna Hotpoint',
  indefinitely: 'Toistaiseksi',
  indexIncludeTimestamp: 'Indeksiin sisällytettävä aikaleima',
  indexLane: 'Indeksikaista',
  indexQueueJob: 'Indeksijono',
  indexed: 'Indeksoitu',
  indexingConfiguration: 'Indeksoinnin konfigurointi',
  info: 'Info',
  information: 'Tiedot',
  inherit: 'Periä',
  inherited: 'Peritty',
  inheritedParent: 'Peritty Ylätasolta.',
  inputSource: 'Syötelähde',
  inputSpecification: 'Syötteen Määritys',
  inputType: 'Syötetyyppi',
  inputTypeListboxWarning: 'Lajittelumääritykset näkyvät tallennettaessa',
  insertDataField: 'Lisää tietokenttä',
  integration: 'Integrointi | Integroinnit',
  integrationsAddPartToErpCart: '{action} Lisää Osa ERP-ostoskoriin',
  integrationsAddToShoppingCartPricingFromErp: '{action} Lisää Ostoskorin Hinnoittelu ERP:stä',
  integrationsDisableErp: 'Poista ERP Käytöstä',
  integrationsDoErpForQuotes: 'Tee ERP Tarjouksille',
  integrationsEnableErp: 'Ota ERP Käyttöön',
  integrationsEnableFetchPartInfoFromErp: 'Ota Käyttöön Hae Osatieto ERP:stä',
  integrationsEnableScopeErp: 'Ota {scope} ERP Käyttöön',
  integrationsEnableSendShoppingCartToErp: 'Ota Käyttöön Lähetä Ostoskori ERP:iin',
  integrationsEnableSyncPoAddressWithErp: 'Ota käyttöön Synkronoi Ostotilauksen Osoite ERP:n kanssa',
  integrationsErpAvailabilityMappedFrom: 'ERP-Saatavuus Yhdistetty Kohteesta',
  integrationsErpCurrencyCodeMappedFrom: 'ERP-Valuuttakoodi Yhdistetty Kohteesta',
  integrationsErpDiscountedPriceMappedFrom: 'Alennettu ERP-Hinta Yhdistetty Kohteesta',
  integrationsErpEtaMappedFrom: 'ERP ETA Yhdistetty Kohteesta',
  integrationsErpMappings: 'ERP-Yhdistämiset',
  integrationsErpRetailPriceMappedFrom: 'ERP-Jälleenmyyntihinta Yhdistetty Kohteesta',
  integrationsErpWholesalePriceMappedFrom: 'ERP-Tukkuhinta Yhdistetty Kohteesta',
  integrationsInvokeGetPartInfoFromClient: 'Pyydä GetPartInfo Asiakkaalta',
  integrationsParseAddressForType: 'Jäsennä Osoite Tyypille',
  integrationsShoppingCartAndPartsTitle: 'Ostoskori ja Osat',
  integrationsShoppingCartAvailability: '{action} Ostoskorin Saatavuus',
  integrationsShoppingCartEtaFromErp: '{action} Ostoskorin ETA ERP:stä',
  internalApiKey: 'Sisäinen API-avain',
  internalDescription: 'Sisäinen Kuvaus',
  internalName: 'Sisäinen Nimi',
  internalNameOptional: 'Tunnisteesi tagille',
  internalNameRequired: 'Nimi on pakollinen',
  invalidDecimals: 'Vain kaksi desimaalia on sallittu',
  invalidField: '{field} on virheellinen',
  invalidFileType: 'Tiedostotyyppiä ei tueta. Saat Documoton Tukikeskuksesta kattavan listan tuetuista tiedostotyypeistä.',
  isSearchable: 'On Haettavissa',
  isSystem: 'On Järjestelmä',
  italianDescription: 'Italia Kuvaus',
  italianName: 'Italia Nimi',
  item: '#',
  itemAlt: 'Kohde',
  itemCopied: '{item} kopioitu',
  itemDeleted: '{item} poistettu',
  itemDetails: 'Kohteen yksityiskohdat',
  itemInProgress: '{item} on käynnissä',
  itemInformation: 'Kohteen {item} tiedot',
  itemMustBeLteItem: 'Kohteen {itemA} on oltava sama tai aikaisempi kuin kohteen {itemB}.',
  itemMustBeUnique: 'Kohteen {item} on oltava yksilöllinen',
  itemMustBeUniqueAndNotEmpty: 'Kohteen {item} on oltava yksilöllinen ja se on pakollinen',
  itemName: 'Kohteen {item} Nimi',
  itemSaved: '{item} tallennettu',
  itemSpecification: 'Kohteen Määritys',
  january: 'Tammikuu',
  japaneseDescription: 'Japani Kuvaus',
  japaneseName: 'Japani Nimi',
  job: 'Työ | Työt',
  jobManager: 'Job Manager',
  jobManagerMessage: 'Vie, julkaise ja tulosta/lataa töitä',
  july: 'Heinäkuu',
  june: 'Kesäkuu',
  knowledgeBase: {
    config: {
      fetchUsage: 'Hae käyttö',
      maxTokensDefault: 'Kuukausittainen oletusarvoinen enimmäistokenimäärä',
      maxTokensOverride: 'Kuukausittaisen enimmäistokenimäärän ohitus',
      noData: 'Määritystietoja ei ole saatavilla.'
    },
    errors: {
      maxFileSizeExceeded: 'Tiedosto ylittää tietopankin sallitun tiedostokokorajan.',
      maxTokensExceeded: 'Olet saavuttanut token-rajan.',
      pageNavigationFailed: 'Sivulle siirtyminen epäonnistui.'
    },
    feedback: {
      prompt: 'Kiitos ilmoituksesta. Mikä tässä vastauksessa oli vialla?',
      reasons: {
        hardToUnderstand: 'Vaikea ymmärtää',
        incorrect: 'Väärin',
        missingInfo: 'Tietoja puuttuu',
        offTopic: 'Aiheen ulkopuolella'
      },
      submitted: 'Palautteesi on lähetetty.'
    },
    library: {
      buttonText: 'Kysy tekoälyltä',
      disclaimer: 'Documoto AI saattaa tehdä virheitä. Tarkista vastaukset oikeellisuuden varalta.',
      inputPlaceholder: 'Esitä kysymys…',
      noContent: 'Tälle asiakirjalle ei ole saatavilla kontekstia.',
      promptDefault: 'Kysymyksiin vastataan vain tämän asiakirjan perusteella. Esitä yksi kysymys kerrallaan.',
      reference: 'PDF-viite',
      serviceError: 'Virhe kontekstia luotaessa.',
      title: 'Tekoälypohjainen haku'
    },
    tenantKnowledgeBase: 'Vuokraajakohtainen tietopankki',
    usage: {
      inputTokens: 'Syötetokenien kokonaismäärä',
      noData: 'Käyttötietoja ei ole saatavilla.',
      outputTokens: 'Tulotokenien kokonaismäärä',
      title: 'Token-käytön yhteenveto',
      totalTokens: 'Käytettyjen tokenien kokonaismäärä'
    }
  },
  koreanDescription: 'Korea Kuvaus',
  koreanName: 'Korea Nimi',
  label: 'Nimitys | Nimitykset',
  labelKey: 'Nimityksen Selite',
  landscape: 'Vaaka',
  laneConfiguration: 'Kaistan konfigurointi',
  language: 'Kieli',
  largePDFDownloadWarning: 'PDF-tiedoston suuren koon vuoksi asiakirjan lataaminen ja näyttäminen sovelluksessa voi kestää tavallista pidempään. Odota kärsivällisesti, että tiedosto latautuu katselua varten.',
  lastGenerated: 'Viimeksi Luotu',
  lastModifiedDate: 'Viimeinen muokkauspäivä',
  lastName: 'Sukunimi',
  lastNameEmpty: 'Sukunimi ei voi olla tyhjä',
  lastUpdatedOn: 'Viimeksi päivitetty',
  layout: 'Asettelu',
  layoutOptions: 'Asetteluvaihtoehdot',
  ledger: 'Pääkirja',
  left: 'Vasen',
  legal: 'Legal',
  letter: 'Letter',
  library: 'Kirjasto',
  libraryAdmin: 'Kirjaston Ylläpitäjä',
  libraryBannerLogo: 'Kirjaston bannerilogo',
  librarySettings: 'Kirjaston Asetukset',
  librarySettingsDescription: 'Näillä asetuksilla hallitaan Kirjaston eri elementtejä ja vaihtoehtoja. Tee muutokset huolella. Ota yhteyttä Documoton Palveluihin lisätietojen saamiseksi.',
  licenseConfiguration: 'Lisenssin konfigurointi',
  line: 'Rivi',
  lineTool: 'Viivatyökalu',
  link: 'Linkki | Linkit',
  listBox: 'Luetteloruutu',
  listBoxValue: 'Luettele Ruutuarvo | Luettele Ruutuarvot',
  listValue: 'Luettele Arvo | Luettele Arvot',
  load: 'Lataa',
  loadMore: 'Lataa lisää',
  loading: 'Ladataan',
  loadingParts: 'Ladataan osia',
  locale: 'Kieliasetus',
  logiReportName: 'Logi-raportin nimi',
  logiReportToggle: 'Logi-raportti?',
  login: 'Kirjaudu sisään',
  loginBackground: 'Kirjautumisen Tausta',
  loginGDPRMessageBeginning: 'Tämä sivusto käyttää evästeitä. Jos jatkat tämän sivuston käyttöä, annat suostumuksesi evästeiden käyttöön. Katso lisätietoja kohdasta ',
  loginGDPRMessageEnd: 'ja kohdasta',
  loginSSO: 'Kirjaudu (SSO)',
  logo: 'Logo | Logot',
  logout: 'Kirjaudu ulos',
  lookupLoadParts: 'Etsi/Lataa Osia Dokumotosta Tuonnin yhteydessä',
  lowerBound: 'Alaraja',
  mOfNShown: 'Näytetään {m} / {n}',
  mToM: 'M2M',
  mainInfo: 'Päätiedot',
  mainLogo: 'Päälogo',
  makePagesDivisibleBy: 'Tee Sivuista Jaollisia Seuraavasti:  ',
  manageItem: 'Hallitse kohdetta {item}',
  management: 'Hallinta',
  manuallyResetPassword: 'Palauta salasana manuaalisesti',
  manuallySetPassword: 'Aseta salasana manuaalisesti',
  march: 'Maaliskuu',
  margin: 'Marginaali | Marginaalit',
  markdown: 'Hinnanalennus',
  maxCharHelpMessage: 'Aseta mikä tahansa arvo {min} ja {max} merkin väliltä merkkien enimmäisrajaksi.',
  maxCharacters: 'Enimmäismerkkimäärä',
  may: 'Toukokuu',
  media: 'Media | Mediat',
  mediaBookDeleteMessage: 'Tämän median poistaminen poistaa pääsyn tähän sisältöön sekä Kirjastossa että Sisällön Hallinnassa ja se ei ole enää käyttäjien tai Sisällönvalvojien käytettävissä. Mitään tämän kirjan osia tai sivuja, joita ei löydy muista kirjoista, ei myöskään ole enää saatavissa Kirjastossa.',
  mediaCategory: 'Mediakategoria | Mediakategoriat',
  mediaCategoryEditor: 'Mediakategorian Editori',
  mediaCategoryName: 'Mediakategorian Nimi',
  mediaCategoryNameMissing: 'Kaikki mediakategoriat vaativat nimen',
  mediaDeleteMessage: 'Tämän mallineen poistaminen poistaa sen Sisällön Hallinnasta ja se ei enää ole saatavissa kopioitavaksi uuteen Mediaan.',
  mediaDeleteSuccessText: 'Se poistetaan luetteloista, kun indeksointi on valmis.',
  mediaDescription: 'median kuvaus',
  mediaIdentifier: 'median tunniste',
  mediaIdentifierDescription: 'Sisäinen medianumero, jota loppukäyttäjät voivat hakea',
  mediaName: 'Median nimi',
  mediaPrintSettingsSaveSuccess: 'Median Tulostusasetukset tallennettu',
  mediaWhereUsed: 'Käytetty Mediassa',
  menu: 'Valikko',
  merge: 'Yhdistä',
  mergeOrOverrideMessage: 'Haluatko korvata tai yhdistää nämä kohteet?',
  mergeWarning: 'Datan tuonti päivittää nykyiset osat ja lisää uusia syötteitä',
  message: 'Viesti',
  messageLevel: 'Viestin Taso',
  messageMessage: 'Viesti on pakollinen',
  metadata: 'Metadata',
  microsite: 'Mikroalue | Mikroalueet',
  micrositeAdmin: {
    cardSubtitle: 'Pakatun sisältötiedoston ja HTML-syötetiedot',
    cardTitle: 'Sivun sisältö',
    errorRequiredFile: 'Sivun sisältö-ZIP-tiedosto tarvitaan',
    fieldFile: 'Sivun sisältö-ZIP-tiedosto',
    fieldPoint: 'HTML-aloituspiste'
  },
  minArea: 'Pienin Alue',
  minAreaMessage: 'Vähimmäisarvo on pakollinen. Arvo ei saa ylittää väliä 1–1500.  On oltava kokonaislukuarvo.',
  minCharacters: 'Vähimmäismerkkimäärä',
  minMaxCharHelpMessage: 'Aseta mikä tahansa arvo {min} ja {max} merkin väliltä merkkien vähimmäis-/enimmäisrajaksi. Enimmäisarvon on oltava suurempi tai yhtä suuri kuin vähimmäisarvo.',
  mine: 'Oma',
  miscellaneous: 'Sekalaista',
  mon: 'Ma',
  month: 'Kuukausi',
  moreInfo: 'Lisätiedot',
  multipleAlternatingPages: 'Useita Vuorottelevia Sivuja',
  multipleAlternatingPagesMessage: 'Kaavio sivuilla 1 ja 3, osaluettelo sivuilla 2 ja 4.',
  multiplePages: 'Useita Sivuja',
  multiplePagesMessage: 'Kaavio omalla sivullaan, minkä jälkeen osaluettelon sivut',
  myCart: 'Oma Ostoskori | Omat Ostoskorit',
  nItemsCreated: '{n} {items} Luotu',
  nItemsDeleted: '{n} {items} Poistettu',
  nOfMItems: '{n}/{m} {items}',
  name: 'Nimi',
  nameDescriptionHelpText: 'Nimi ja valinnainen kuvaus',
  navigation: 'Navigointi',
  'new': 'Uusi',
  newAPIKey: 'Uusi API-avain',
  newERPSystem: 'Uusi ERP-järjestelmä',
  newItem: 'Uusi {item}',
  newKeyGenerated: 'Uusi Integrointiavain Luotu, Kopioitu ja Säilytetty tulevaa käyttöä varten',
  newMediaCategory: 'Uusi Mediakategoria',
  newPassword: 'Uusi Salasana',
  newTenant: 'Uusi vuokraaja',
  newWidgetKey: 'Uusi widget-avain',
  newWidgetKeyGenerated: 'Uusi widget-avain luotu, kopioi ja säilytä tulevaa käyttöä varten',
  newsItem: 'Uutinen| Uutiset',
  noAPIKeys: 'Ei määriteltyjä API-avaimia.',
  noData: 'Ei Tietoja',
  noFileSelected: 'Tiedostoa ei ole valittu',
  noFilesSelected: 'Ei valittuja Tiedostoja',
  noFormsMessage: 'Lomakkeita ei ole määritetty.',
  noIllustrationFound: 'Kuvia ei Löytynyt',
  noImageFound: 'Kuvaa ei Löytynyt',
  noItemAddedToTarget: 'Mitään {item} ei lisätty {target}. ',
  noItemAvailable: 'Kohdetta {item} ei saatavilla',
  noItemFound: 'Tuotetta {item} ei löydy.',
  noItemSelected: 'Kohdetta {item} ei valittuna',
  noItemsFound: 'Tuotteita Ei Löytynyt',
  noMediaDefined: 'Ei määriteltyä mediaa',
  noMoreResults: 'Ei enempää tuloksia',
  noPartCollectionsFound: 'Ei löytynyt kohdetta {partCollection}.',
  noPartsSelected: 'Ei valittuja osia.',
  noPrice: 'Pyydä Hinta',
  noResults: 'Ei tuloksia',
  noSearchResultsHelpText: 'Tuloksia ei löytynyt',
  noSearchableCategories: 'Ei haettavia kategorioita',
  noSearchableTags: 'Ei haettavia tageja',
  noSuggestions: 'Ei ehdotuksia hakusanalle',
  noSupercedingPartsFoundForPartNumber: 'Tälle osanumerolle ei löytynyt korvaavia osia.',
  noTagsFound: 'Ei löytynyt tunnisteita',
  noTenantSuppliers: 'Vuokraajalle ei ole nimetty toimittajia.',
  noUnsavedChanges: 'Ei Tallentamattomia Muutoksia',
  noWidgetKeys: 'Ei määritelty widget-avaimia.',
  node: 'Solmu',
  nonSearchableFieldsSuccessfullyUpdated: 'Ei haettavissa olevat kentät päivitetty onnistuneesti.',
  none: 'Ei mitään',
  norwegianDescription: 'Norja Kuvaus',
  norwegianName: 'Norja Nimi',
  notAvailable: 'Ei sovelleta',
  notImplemented: 'Ei Otettu Käyttöön',
  notMapped: 'Ei Kartoitettu',
  notOrderable: 'Ei Tilattavissa',
  notSelected: 'Ei valittu',
  notification: 'Ilmoitus | Ilmoitukset',
  notificationsMessage: 'Tärkeät tiedotukset ja uutiset',
  november: 'Marraskuu',
  numberOf: '# /{item}',
  numeric: 'Numeerinen',
  october: 'Lokakuu',
  of: '/',
  off: 'Pois päältä',
  offlineContent: 'Offline-Sisältö',
  ok: 'Ok',
  oldPassword: 'Vanha salasana',
  on: 'Päällä',
  opacity: 'Läpinäkyvyys',
  open: 'Avoin',
  openItem: 'Avaa {item}',
  openTab: 'Avaa linkki uudessa välilehdessä',
  optimizeIndexJob: 'Optimoi Indeksi',
  optionalConfiguration: 'Valinnainen määritelmä | Valinnaiset määritelmät',
  options: 'Vaihtoehdot',
  order: 'Tilaus | Tilaukset',
  orderAttachmentHelpText: 'Voit liittää enintään 10 tiedostoa, kukin enintään 50 MB. Sallitut tiedostotyypit: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v, svg',
  orderDisable: 'Poista Tilaushistoria Käytöstä',
  orderEmailRecipient: 'Tilaussähköpostin Vastaanottaja | Tilaussähköpostin Vastaanottajat',
  orderEntity: 'Tilauskokonaisuus | Tilauskokonaisuudet',
  orderField: {
    nameMessage: 'Jos vaihdat Tilaus-/tarjouskentän nimeä, muista päivittää kaikki Tilaus-/tarjouslomakkeet tai Sähköpostiformaatit, jotka käyttävät tätä kenttää.'
  },
  orderFieldCopyMessage: 'Anna uudelle Tilaus-/tarjouskentälle yksiselitteinen nimi',
  orderFieldUneditableRequired: 'Tilaus-/tarjouskentän asettaminen Pakolliseksi eikä Käyttäjän Muokattavaksi voi tehdä Tilaus-/tarjouslomakkeen täyttämisen mahdottomaksi. Varmista, että Tilaus-/tarjouslomakkeesi voidaan täyttää.',
  orderFieldsEmptyMessage: 'Tilaus-/tarjouskenttiä ei ole määritelty.',
  orderFieldsEmptyPrompt: 'Lisää Tilaus-/tarjouskenttä',
  orderForm: {
    uniqueNameInputHint: 'Anna tälle uudelle Lomakkeelle yksilöllinen nimi.'
  },
  orderFormField: 'Tilaus-/tarjouskenttä | Tilaus-/tarjouskentät',
  orderFormLayout: 'Tilaus-/tarjouslomakkeen Asettelu | Tilaus-/tarjouslomakkeen Asettelut',
  orderFormSetDefault: 'Tilaus-/Tarjouslomakkeen oletussarja',
  orderFormType: 'Tilauslomake',
  orderLayout: 'Tilauspohja | Tilauspohjat',
  orderManagementApprover: 'Tilaushallinnan Hyväksyjä',
  orderManagementDisable: 'Poista Tilaushallinnan Ylläpito Käytöstä',
  orderManagementViewer: 'Tilaushallinnan Katsoja',
  orderNumber: 'Tilausnumero',
  orderQuoteDeleteWarning: 'Ei voida poistaa kenttiä, jotka ovat käytössä tilaus- tai tarjouslomakkeessa, joita käytetään sähköpostimallina tai joita on käytetty aiemmin lähetetyissä tilauksissa tai tarjouksissa.',
  orderQuoteEmail: 'Tilauksen/tarjouksen sähköposti | Tilausten/tarjousten sähköpostit',
  orderQuoteEmailFormat: 'Tilauksen/tarjouksen sähköpostimuoto | Tilausten/tarjousten sähköpostimuodot',
  orderQuoteEmailFormatCopyMessage: 'Valitse uuden tilauksen/tarjouksen sähköpostimuodon kieli.',
  orderQuoteFetchError: 'Virhe noudettaessa tilaus-/tarjouslomakkeen tietoja',
  orderQuoteForm: 'Tilaus-/Tarjouslomake | Tilaus-/Tarjouslomakkeet',
  orderQuoteFormSaved: 'Tilaus-/tarjouslomake tallennettu',
  orderQuoteSaveConfirmation: 'Tallennetaanko organisaation tilaus-/tarjouslomakkeiden muutokset?',
  orderQuoteSaveError: 'Virhe tallennettaessa tilaus-/tarjouslomakkeen tietoja',
  orderStatus: 'Tilauksen/tarjouksen tila | Tilausten/tarjousten tilat',
  orderStatusDeleteMessage: 'Tätä tilaa on käytetty tilauksissa, eikä sitä voi poistaa.',
  orderSubmittedMessage: 'Lähetys Onnistui',
  orderSuggestion: 'Tilausehdotus | Tilausehdotukset',
  orderSuggestionEnable: 'Ota Tilausehdotukset Käyttöön',
  orderSuggestionRemovalWarning: 'Osa ei enää näy tilausehdotuksena. | Osat eivät enää näy tilausehdotuksina.',
  orderSuggestionThreshold: 'Tilausehdotuksen Raja-arvo',
  orderable: 'Tilattavissa',
  orderableDescription: 'Osan voi lisätä ostoskoriin ja ostaa',
  orderableLocal: 'Tilattavissa tällä sivulla',
  orderableLocalBlocked: 'Osa ei ole Yleisesti Tilattavissa',
  ordersLogo: 'Tilausten Logo',
  ordersMessage: 'Tilauslähetyshistoria',
  org: 'Alkup.',
  orgAccessControlsWarning: 'Huomautus: vanhemmat organisaatiot (kuten vanhempien tai isovanhempien taso) saavat automaattisesti käyttöoikeuden, joka on annettu niiden aleneville organisaatioille (kuten lapsi- tai lapsenlapsitason organisaatioille).',
  orgEmailRecipients: 'Organisaation Sähköpostin Vastaanottajat',
  orgNameOnly: 'Vain Alkup. Nimi',
  organization: 'Organisaatio | Organisaatiot',
  organizationAdmin: 'Organisaation Hallinta',
  organizationAdminBrowseFlow: 'Organisaatio voi käyttää oletusselausjärjestystä tai sen voi ohittaa ja käyttää jotain muuta selausjärjestystä.',
  organizationAdminMessage: 'Hallitsee käyttäjänhallintaa ja organisaatioasetuksia',
  organizationEmailRecipients: 'Organisaation Sähköpostin Vastaanottajat',
  organizationEmpty: 'Organisaatio on valittava',
  organizationEnforceAccessControlsForQuickAdd: 'Pikalisäyksen pääsynvalvonnan käyttöönotto',
  organizationKey: 'Organisaation Selite',
  organizationLibrarySettingsDescription: 'Näillä asetuksilla hallitaan Organisaatiotasoisia Kirjaston elementtejä ja vaihtoehtoja. Tee muutokset huolella. Ota yhteyttä Documotoon lisätietojen saamiseksi.',
  organizationMoveToRoot: 'Pudota tähän siirtääksesi juureen',
  organizationName: 'Organisaation nimi',
  organizationRearrange: 'Järjestä Organisaatiot Uudelleen',
  organizationRearrangeDescription: 'Hierarkkinen Organisaatiorakenne määrittää monia Organisaation periytyviä ominaisuuksia kuten Tulostusasetuksia, Tyylejä jne. Vedä ja pudota Organisaatiot haluamaasi hierarkiaan.',
  organizationReportSettingsSuccessMessage: 'Raportointiasetukset tallennettu',
  organizationSelect: 'Valitse Organisaatio',
  organizationTags: 'Organisaation Tagit',
  organizationsEmpty: 'Et ole luonut vielä yhtään organisaatiota',
  orientation: 'Suunta',
  other: 'Muu',
  otherSettings: 'Muut Asetukset',
  outboundCustomerIdParameter: 'Uloslähtevä Asiakastunnuksen Parametrin Nimi',
  outboundSessionIdParameter: 'Uloslähtevä Tilaisuuden Tunnuksen Parametrin Nimi',
  outlineMode: 'Ääriviivatila (Shift O)',
  output: 'Tuloste',
  outputCatalog: 'Tulosteluettelo',
  outputDefinition: 'Tulosteen määritelmä | Tulosteen määritelmät',
  outputDefinitionDeleted: 'Tulostemääritelmä poistettu',
  outputDefinitionSaved: 'Tulostemääritelmä tallennettu',
  outputDestination: 'Tuloksen kohde',
  outputFileName: 'Tulostiedoston nimi',
  outputName: 'Tulosteen nimi',
  outputSpecification: 'Tuloksen tiedot',
  outputSubType: 'Tulosteen alityyppi',
  outputType: 'Tulosteen tyyppi',
  overridden: 'Ohitettu',
  overriddenByOrg: 'Organisaation Ohittama',
  override: 'Ohita',
  overrideBrowseFlow: 'Ohita Selausjärjestys',
  overrideFacetLimitValue: 'Ohita fasetin rajoitusarvo',
  overrideFontSettings: 'Ohita Fonttiasetukset',
  overrideHotpointScale: 'Ohita Kohdepisteskaalaus',
  overrideOrderForm: 'Ohita tilauslomake',
  overridePdfNamingStandard: 'PDF-tiedostojen nimeämisstandardin ohittaminen',
  overridePrintSettings: 'Ohita Tulostusasetukset',
  overrideQuoteForm: 'Ohita tarjouslomake',
  overrideSvgOpacity: 'Ohita SVG-Peittävyys',
  overrideWarning: 'Datan tuonti korvaa nykyisen BOM-luettelosi',
  owner: 'Omistaja | Omistajat',
  page: 'Sivu | Sivut',
  pageBomPartsDeleted: '{count} Sivun BOM-osat eivät enää ole käytettävissä {filename}kautta.',
  pageBuilder: 'Sivunrakentaja',
  pageBulkErrorTooManyBooks: 'Rajaa valittujen kirjojen määrää enintään arvoon 1000',
  pageBulkInsertBooksConfirmInsertAfter: 'Tämä liittää {replacement}  {original} jälkeen kohdassa {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertBefore: 'Tämä liittää {replacement} ennen {original} kohdassa {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertReplace: 'Tämä liittää {replacement} ja poistaa {original} kohdassa {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertConfirmInsertAfter: 'Tämä liittää {replacement}  {original} jälkeen kohdassa {whereUsedBookCount} {bookUnits} ja {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertBefore: 'Tämä liittää {replacement} ennen {original} kohdassa {whereUsedBookCount} {bookUnits} ja {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertReplace: 'Tämä liittää {replacement} ja poistaa {original} kohdassa {whereUsedBookCount} {bookUnits} ja {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmTitle: 'Haluatko suorittaa joukkolisäyksen?',
  pageBulkInsertDiscard: 'Joukkolisäystä ei käsitellä.',
  pageBulkInsertHelpText: 'Tämä toiminto sallii sinun lisätä tämän lähdesivun {thisDisplayName} valittuihin varaosakirjoihin, joissa on jo toinen sivu {originalDisplayName}. Vaihtoehtoisesti voit myös poistaa {originalDisplayName} noista kirjoista.',
  pageBulkInsertInsertAfter: 'Lisää {replacement} kohteen {original} JÄLKEEN',
  pageBulkInsertInsertBefore: 'Lisää {replacement} ENNEN kohdetta {original}',
  pageBulkInsertInsertReplace: 'Lisää {replacement} ja POISTA {original}',
  pageBulkInsertScopeAll: 'All {type} jolla on kohdesivu {originalDisplayName} ({whereUsedCount} {units})',
  pageBulkInsertScopeNone: 'Ei mikään {type} jolla on kohdesivu {originalDisplayName}',
  pageBulkInsertScopeSome: 'Osa {type} joilla on kohdesivu {originalDisplayName}',
  pageBulkInsertStep1: 'Vaihe 1: Etsi haluttu kohdesivu',
  pageBulkInsertStep2: 'Vaihe 2: Päätä, miten sivujen lisäys tai korvaus tapahtuu',
  pageBulkInsertStep3: 'Vaihe 3: Valitse kirjat, joissa haluat joukkolisäyksen käsiteltävän.',
  pageBulkInsertStep4: 'Vaihe 4: Valitse mallit, joissa haluat joukkolisäyksen käsiteltävän.',
  pageBulkInsertSuccessBody: 'Kirjan sisällysluettelon muutokset tehdään välittömästi. Ne heijastuvat hakutuloksissa, kun indeksointi on valmis.',
  pageBulkInsertSuccessTitle: 'Joukkolisäystyö lähetetty',
  pageBulkInsertTemplatesConfirmInsertAfter: 'Tämä liittää {replacement}  {original} jälkeen kohdassa {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'Tämä liittää {replacement} ennen {original} kohdassa {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'Tämä liittää {replacement} ja poistaa {original} kohdassa {whereUsedTemplateCount} {templateUnits}.',
  pageComposer: 'Page Composer',
  pageCreated: 'Sivu Luotu',
  pageDeleteMessage: 'Sivujen poistot tulevat voimaan välittömästi kirjaston ja sisällön hallinnassa. Poistettu sivu pysyy hakukelpoisena, kunnes indeksointi on suoritettu uudelleen muutaman minuutin kuluessa.',
  pageDeleteMessage2: 'Tätä toimenpidettä ei voi perua ilman Documoto-tuen apua. Poistettu tietue ja kaikki assosiaatiot poistetaan pysyvästi 90 päivän kuluttua.',
  pageDescription: 'Sivun kuvaus',
  pageDraftsDeleted: 'Tälle sivulle liittyvät luonnossivut poistetaan pysyvästi.',
  pageFile: 'Sivutiedosto',
  pageFileRequired: 'Sivutiedosto on pakollinen.',
  pageFilename: 'Sivun tiedostonimi',
  pageFilenameDeleted: '{filename} poistetaan.',
  pageFit: 'Sivun Sovitus',
  pageHeader: 'Sivun Ylätunniste',
  pageLabel: 'Sivu | Sivut',
  pageLayout: 'Sivupohja',
  pageName: 'Sivun nimi',
  pagePart: 'Sivun Osa | Sivun Osat',
  pagePartData: 'Sivun osan tiedot',
  pagePartLevelDetails: 'Sivun osa tilattavissa/nähtävissä, Sivun osan tunnisteet',
  pagePartNumberVisible: 'Sivun Osanumero näkyvillä',
  pagePartOrderable: 'Sivun Osa Tilattavissa',
  pagePartOrderableDescription: 'Osa Tilattavissa tältä sivulta',
  pagePartTag: 'Sivun Osamerkki | Sivun Osamerkit',
  pagePartVisibleDescription: 'Osanumero näkyvillä tällä sivulla',
  pageToPartCollectionFailure: 'Sivun {name} lisääminen osakokoelmana epäonnistui.',
  pageUpdated: 'Sivu Päivitetty',
  pageUsageDataCouldNotBeLoaded: 'Sivun käyttötietoja ei voitu ladata',
  pageViewer: 'Sivun katseluohjelma',
  pageWidth: 'Sivun Leveys',
  pagesWhereUsed: 'Käytetty Sivuilla',
  parentName: 'Ylätason Nimi',
  part: 'Osa | Osat',
  partCode: 'Osakoodi | Osakoodit',
  partCodeAddError: 'Sivukoodia(-koodeja) Ei Voi lisätä',
  partCodeErrorEmpty: 'Ei voitu tallentaa: Osakoodi ei voi olla tyhjä',
  partCodeErrorInUse: 'Tätä osakoodia käytetään Documoton osissa, eikä sitä voi poistaa. Ota yhteyttä Documoton Tukeen osoitteessa support{\'@\'}documoto.com lisätietojen saamiseksi.',
  partCodeErrorNotFound: 'Tätä osakoodia ei voitu poistaa, koska sitä ei löytynyt. Varmista, että kaikki muutokset on tallennettu.',
  partCodesManager: 'Osakoodien Hallintatoiminto',
  partCodesMessage: 'Osakoodeja voidaan käyttää osanumeroiden sijasta, ja niitä käytetään usein osoittamaan, että BOM-kohde on vanhentunut, se ei ole saatavilla tai se on vain referenssituote (esim. \'PNNA\', \'-\', \'REF\').',
  partCollection: 'Osakokoelma | Osakokoelmat',
  partCollectionsDescription: 'Lisää enintään 20 {parts} {pages} näytettäväksi muodossa {collections} tässä kohteessa {productPage}.',
  partCollectionsDescription2: 'Valitut {collections} määrittävät, mitkä {parts} ovat loppukäyttäjien saatavilla nopeaa käyttöä tai tilaamista varten.',
  partCollectionsDescription3: 'Alla määritetty järjestys ohjaa sitä, miten ne näkyvät kirjaston {productPage} katseluohjelmassa.',
  partCollectionsLimitError: 'Enintään {limit} {item1} on sallittu kohdetta {item2} kohden.',
  partCreated: 'Osa Luotu',
  partData: 'Osatiedot',
  partDebouncerEmailQueueJob: 'Sähköpostijono',
  partDescription: 'Osan kuvaus',
  partEquipmentVerificationBanner: 'Osan laitteen tarkistusbanneri',
  partLabel: 'Osa | Osat',
  partLevelDetails: 'Osan hinnoittelu, Tilattavissa/nähtävissä, Lisäkäännökset, Osan tunnisteet',
  partName: 'Osan Nimi',
  partNumber: 'Osanumero',
  partNumberCopied: '{label} kopioitu leikepöydälle',
  partNumberDescription: 'Sisäinen osanumero, jota loppukäyttäjät voivat hakea',
  partNumberSupercededBy: '{partNumber} esiintyy SupersededPartNumber-tunnisteena…',
  partNumberVisible: 'Osanumero näkyvillä',
  partNumberVisibleDescription: 'Osanumero näkyy loppukäyttäjille',
  partNumberVisibleLocal: 'Näkyvillä tällä sivulla',
  partNumberVisibleLocalBlocked: 'Osanumero ei ole Yleisesti Näkyvillä',
  partOrderable: 'Osa Tilattavissa',
  partRequired: 'Vähintään yksi osa vaaditaan',
  partTag: 'Osamerkki | Osamerkit',
  partTagProperty: 'Osan Tagin Ominaisuus | Osan Tagin Ominaisuudet',
  partUpdated: 'Osa päivitetty',
  partVerificationInstructions: 'Tarkista, että tämä osa sopii laitteellesi',
  partialSupport: 'Osittainen Tuki',
  partnerApiKey: 'Kumppanin API-avain',
  partnerRESTRequestLimit: 'Kumppanin REST-pyyntörajoitus',
  partsBook: 'Varaosakirja | Varaosakirjat',
  partsBulkImport: {
    description: 'Lataa datatiedostosi lähettääksesi osien massatuonnin käsittelyyn. Tuettu tiedostomuoto: XLSX.',
    downloadTemplate: 'Lataa XLSX-malli',
    downloadUnprocessedRows: 'Lataa käsittelemättömien rivien laskentataulukko',
    hideRequirements: 'Piilota XLSX-vaatimukset',
    overwriteTagValues: 'Korvaa vastaavien tunnisteiden tunnistearvot',
    overwriteTranslations: 'Korvaa vastaavat käännökset',
    requirements: {
      discountPrice: {
        description: 'Asettaa vuokralaistason (tenant-level) alennushinnan.'
      },
      enUSDescription: {
        description: 'Kielikohtainen käännöskuvaus osalle. Katso <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">kielitukioppaamme</a>.'
      },
      enUSName: {
        description: 'Kielikohtainen käännösnimi osalle. Uusille osille vaaditaan vähintään yksi käännös. Katso <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">Language Support Guide</a>.'
      },
      orderable: {
        description: 'Määrittää, voidaanko osa tilata. Sallitut arvot ovat `true` tai `false`. Oletusarvo on `true`.'
      },
      orgDiscountPrice: {
        description: 'Asettaa organisaatiotason alennushinnan määritetylle organisaatiolle. Otsikkoesimerkki: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Asettaa organisaatiotason vähittäishinnan määritetylle organisaatiolle. Otsikkoesimerkki: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Asettaa organisaatiotason tukkuhinnan määritetylle organisaatiolle. Otsikkoesimerkki: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Osan yksilöllinen tunniste.'
      },
      retailPrice: {
        description: 'Asettaa vuokralaistason (tenant-level) vähittäishinnan.'
      },
      supplier: {
        description: 'Osan toimittajan nimi.'
      },
      tagInternalName: {
        description: 'Määrittää tunnisteet (tagit) osalle. Otsikon on oltava tunnisteen sisäinen nimi. Jos arvoja on useita, käytä erottimena merkkiä &#124;. Esimerkki: Punainen&#124;Vihreä&#124;Sininen.'
      },
      thumbnail: {
        description: 'Pikkukuvan tiedostonimi. Sallitut tiedostopäätteet: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Mittayksikkö (esim. "kpl", "yksikkö").'
      },
      visible: {
        description: 'Määrittää, onko osa näkyvissä. Sallitut arvot ovat `true` tai `false`. Oletusarvo on `true`.'
      },
      wholesalePrice: {
        description: 'Asettaa vuokralaistason (tenant-level) tukkuhinnan.'
      }
    },
    showRequirements: 'Näytä XLSX-vaatimukset',
    submitNote: 'Napsauttamalla “Submit” käynnistyy taustatehtävä ja sinut ohjataan ”Job Manager” -sivulle.',
    success: 'Osien massatuonnin tehtävä luotu',
    title: 'Osien massatuonti'
  },
  partsColumns: 'Osien Sarakkeet',
  partsDisplay: 'Osien näyttö',
  partsList: 'Osaluettelo',
  partsListColumn: 'Osaluettelon Sarake | Osaluettelon Sarakkeet',
  partsListData: 'Osaluettelon Tiedot',
  partsListGridHeader: 'Osaluettelon Taulukon Otsikko',
  partsNotSelected: 'Oletuskuva, jota käytetään osien esikatselukuvissa. Jos mukautettua esikatselukuvaa ei käytetä, Documoto näyttää standardin oletusesikatselukuvan.',
  partsPage: 'Osasivu | Osasivut',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Osien sarakkeiden lataaminen epäonnistui',
    columnsUpdateErrorMsg: 'Osien Sarakkeiden päivittämistä yritettäessä tapahtui virhe',
    columnsUpdateSuccessMsg: 'Osan Sarakkeet päivitetty',
    cropWhitespaceOnImages: 'Rajaa kuvien tyhjä tila',
    excludePartCodesFromPartsLists: 'Jätä Osakoodit Pois Osaluetteloista',
    highlightAlternateRows: 'Korosta Vuorottelevia Rivejä',
    keepBOMOnRight: 'Pidä BOM Oikealla',
    keepImagesOnLeft: 'Pidä Kuvat Vasemmalla',
    printBorderAroundImages: 'Tulosta Raja Kuvien Ympärille',
    printHotpointsOnImages: 'Tulosta Hotpointit Kuviin',
    rotateImagesAutomatically: 'Kierrä Kuvia Automaattisesti'
  },
  partsPages: 'Osasivut',
  password: 'Salasana',
  passwordBlankMessage: 'Salasana ei voi olla tyhjä',
  passwordCannotBeSame: 'Ei voi olla sama kuin nykyinen salasanasi',
  passwordCasingMassage: 'On sisällettävä vähintään yksi pieni kirjain ja yksi iso kirjain',
  passwordCriteriaInfo: 'Uuden salasanasi on vastattava seuraavia kriteereitä:',
  passwordExpiredHeader: 'Salasana umpeutunut',
  passwordExpiredInfo: 'Salasanasi on umpeutunut. Uuden salasanasi on vastattava seuraavia kriteereitä:',
  passwordLowerCaseMessage: 'Salasanassa on oltava vähintään yksi pieni kirjain',
  passwordMinLengthMessage: 'Salasanoissa on oltava vähintään 8 merkkiä',
  passwordNotMatchingMessage: 'Salasanat eivät täsmää',
  passwordOptions: 'Salasanan vaihtoehdot',
  passwordOptionsRequired: 'Salasanan vaihtoehdot eivät voi olla tyhjiä',
  passwordSpecialCharactersMessage: 'Salasanassa on oltava vähintään yksi erikoismerkki',
  passwordUpperCaseMessage: 'Salasanassa on oltava vähintään yksi iso kirjain',
  passwordWillExpire1Day: 'Kirjautumissalasana umpeutuu alle päivän sisällä',
  passwordWillExpire5Days: 'Kirjautumissalasana umpeutuu alle viiden päivän sisällä',
  passwordsMatch: 'Salasanojen vastaavuus',
  pdfImport: {
    aiPdfImports: 'AI PDF -tuonnit',
    aiPdfImportsDescription: 'Hallitse AI PDF -tuonteja automaattista sisällönkäsittelyä varten.',
    createImport: 'Uusi AI PDF -tuonti',
    createImportDescription: 'Valitse PDF-lähtötiedosto ja määritä asetukset poimintaa varten. Tiedostorajoitukset: koko enintään 500 MB ja enintään 3000 sivua.',
    defaultPartNumberCode: 'Osanumerokoodin oletusarvo',
    defaultTranslationLocale: 'Käännösaluekoodin (locale) oletusarvo',
    defaultUomHelpText: 'Käytetään, kun mittayksikkösaraketta ei ole kartoitettu tai kun poimittu BOM-rivi ei sisällä mittayksikköarvoa.',
    defaultUomRequired: 'Vaaditaan, ellei mittayksikköä ole annettu',
    dropFileMessage: 'Pudota tiedosto tähän tai klikkaa ladataksesi',
    fileSizeError: 'Tiedostokoko ylittää 500 MB:n enimmäisrajan',
    importCreatedError: 'Tuonnin luominen epäonnistui',
    importCreatedSuccess: 'Tuonti luotiin onnistuneesti ja asetettiin käsittelyjonoon',
    mapColumnToTag: 'Kartoita sarake sivun osatunnisteeseen (Page Part Tag)',
    monthlyLimitExceeded: 'Kuukausittainen AI PDF -tuontien sivuraja ylittyisi. Ota yhteyttä asiakkuusvastaavaasi (Customer Success Manager) saadaksesi apua.',
    pageNumberFilterInvalidRange: 'Virheellinen sivunumeroalue',
    pageNumberFilterPlaceholder: 'esim. 6, -7, 8-, 9-20',
    partNumberCodeHelp: 'Osanumerokoodi koskee BOM-rivejä, joissa osanumeroarvo on tyhjä',
    pdfImport: 'PDF-tuonti | PDF-tuonnit',
    pdfImportsDescription: 'Hallitse tekoälypohjaisia PDF-tuonteja osatietojen automaattiseksi poimimiseksi PDF-asiakirjoista',
    publishModalFooterHelp: 'Painikkeen "Julkaise" klikkaaminen asettaa jonoon ja käynnistää taustatyön sekä ohjaa sinut takaisin AI PDF -tuontien hallintasivulle, jossa voit seurata julkaisun tilaa.',
    publishSkipAutoHotpointing: 'Ohita sivun automaattinen hotpointing | Ohita sivujen automaattinen hotpointing',
    publishingFinishedNone: 'Tuonnin "{importName}" julkaisu valmis. Sivuja ei julkaistu.',
    publishingFinishedPartial: 'Tuonnin "{importName}" julkaisu valmis. {success} sivu julkaistu, {failed} sivu epäonnistui. | Tuonnin "{importName}" julkaisu valmis. {success} sivua julkaistu, {failed} sivua epäonnistui.',
    publishingFinishedSuccess: 'Tuonnin "{importName}" julkaisu valmis. {count} sivu julkaistu. | Tuonnin "{importName}" julkaisu valmis. {count} sivua julkaistu.',
    reviewStatusAll: 'Tila: Kaikki',
    reviewStatusApproved: 'Hyväksytty',
    reviewStatusDropped: 'Hylätty',
    reviewStatusNoStatus: 'Ei tilaa',
    reviewStatusNone: 'Ei mitään',
    reviewStatusPending: 'Odottaa',
    selectPagePartTag: 'Valitse sivun osatunniste (Page Part Tag)',
    statusDeclined: 'Hylätty',
    statusFailed: 'Epäonnistunut',
    statusPending: 'Odottaa',
    statusProcessing: 'Käsitellään',
    statusPublished: 'Julkaistu',
    statusPublishing: 'Julkaistaan',
    submitNote: 'Painikkeen "Lähetä" klikkaaminen asettaa jonoon ja käynnistää taustatyön sekä ohjaa sinut takaisin AI PDF -tuontien hallintasivulle, jossa voit seurata tuonnin tilaa.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Vastaavuuden tila',
    columnPagePartTag: 'Sivun osatunniste (Page-Part Tag)',
    columnPartNameWithLocale: 'Osan nimi ({locale})',
    emptyState: 'BOM-nimikkeitä ei löytynyt',
    existingPartNameApplied: 'Olemassa olevia osatietoja sovellettu',
    title: 'Osaluettelo (BOM)'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Säädä kuvituksen rajoja',
    boundsAdjusted: 'Rajat säädetty',
    emptyState: 'Tälle sivulle ei ole kuvituksia.',
    hiresUnavailableError: 'Korkearesoluutioista kuvaa ei ole saatavilla tälle sivulle.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Hyväksy valitut ({count})',
    actionClearStatusSelected: 'Tyhjennä valittujen tila ({count})',
    actionCopySelected: 'Yhdistä ensimmäiseen valittuun sivuun',
    actionDeleteImport: 'Poista AI PDF -tuonti',
    actionDropSelected: 'Hylkää valitut ({count})',
    actionPendingSelected: 'Aseta valitut tilaan "Odottaa" ({count})',
    actionPublishSelected: 'Julkaise valitut',
    autoMergeAction: 'Yhdistä sivut automaattisesti',
    autoMergeConfirmHelp: 'Sivujen automaattinen yhdistäminen etsii sivut, joilla on sama sivun nimi, ja yhdistää kunkin vastaavan ryhmän ensimmäiseen sivuun visuaalisessa järjestyksessä. Kohdesivuun yhdistetyt lähtösivut merkitään hylätyiksi. Tarkista tulokset ennen julkaisemista.',
    autoMergeConfirmTitle: 'Yhdistetäänkö sivut, joilla on vastaavat nimet, automaattisesti?',
    autoMergeFailed: 'Automaattinen yhdistäminen epäonnistui, muutoksia ei tehty',
    autoMergeSuccess: 'Automaattinen yhdistäminen valmis: {count} ryhmä(ä) yhdistetty, {dropped} sivu(a) hylätty',
    composedPageIndicator: 'Tämä sivu sisältää muilta PDF-sivuilta kopioitua sisältöä.',
    contentTypeAll: 'Kaikki sisältötyypit',
    contentTypeBomOnly: 'Vain BOM',
    contentTypeBoth: 'Sekä BOM että kuvitukset',
    contentTypeEmpty: 'Tyhjät sivut',
    contentTypeFilterLabel: 'Sisältötyyppi',
    contentTypeIllustrationsOnly: 'Vain kuvitukset',
    importSettings: 'Tuontiasetukset',
    includeDroppedPagesLabel: 'Sisällytä hylätyt sivut',
    incompleteBomFilterLabel: 'Näytä sivut, joiden BOM on keskeneräinen',
    mergeConfirmSourcePages: '{count} lähtösivu valittu: | {count} lähtösivua valittu:',
    mergeConfirmTitle: 'Yhdistetäänkö valitut sivut ensimmäiseen valittuun sivuun?',
    mergeConfirmTarget: 'Kohdesivu: {pageLabel}',
    mergeFailed: 'Sivujen yhdistäminen ensimmäiseen valittuun sivuun epäonnistui',
    mergeSuccess: 'Sivut yhdistetty kohteeseen {pageLabel} ({bomCount} BOM-nimikettä, {illustrationCount} kuvitusta)',
    noPages: 'Sivuja ei ole saatavilla',
    noPagesHint: 'Tämä tuonti ei sisällä yhtään sivua',
    noResults: 'Vastaavia sivuja ei löytynyt',
    noResultsHint: 'Kokeile säätää hakua tai suodattimia',
    notificationLoadFailed: 'Yhteenvedon lataaminen epäonnistui',
    notificationReviewStatusUpdated: '{count} sivu(a) päivitetty onnistuneesti',
    notificationSelectAllFailed: 'Kaikkien sivujen valitseminen epäonnistui',
    notificationUpdateReviewStatusFailed: 'Tarkistustilan päivittäminen epäonnistui',
    publishBookIdentifierNotUnique: 'Kirjan tunnisteen on oltava yksilöllinen.',
    publishBookIdentifierTakenHelp: 'Kirja tällä tunnisteella on jo olemassa.',
    publishFailed: 'Valittujen sivujen julkaiseminen epäonnistui',
    publishModalTitle: 'Julkaise valitut sivut',
    publishNewBookHelpText: 'Onnistuneesti julkaistut sivut lisätään uuteen kirjaan samassa järjestyksessä kuin ne näkyvät AI PDF -tuonnin yleiskatsauksessa. Uusi kirja luodaan vain, jos vähintään yksi valittu sivu julkaistaan onnistuneesti.',
    publishNewBookIdentifierLabel: 'Kirjan tunniste',
    publishOptionNewBook: 'Luo uusi kirja ja lisää sivuja siihen',
    publishOptionPagesOnly: 'Julkaise vain sivut',
    reviewManagement: 'Tarkistuksen hallinta',
    reviewManagementTooltip: 'Käytä tarkistustiloja työsi järjestämiseen, kun tarkistat poimittua sisältöä. Tilat Hyväksytty, Odottaa ja Hylätty eivät vaikuta julkaisemiseen. Ne on tarkoitettu vain tarkistuksen edistymisen seurantaan.',
    reviewProgress: 'Tarkistuksen edistyminen',
    title: 'Yleiskatsaus'
  },
  pdfImportPageDetails: {
    actionPublish: 'Julkaise sivu',
    firstPage: 'Ensimmäinen sivu',
    lastPage: 'Viimeinen sivu',
    matchingPageNewPage: 'Uusi osasivu',
    matchingPageNewPageSharedSvg: 'Uusi osasivu, mutta SVG-tiedosto jaettu muun sivun / muiden sivujen kanssa',
    matchingPageOpenExisting: 'Avaa olemassa oleva sivu',
    matchingPageOverwrite: 'Olemassa oleva osasivu korvataan',
    navLabel: 'AI PDF -tuonnin yleiskatsaus',
    navigationFailedText: 'Sivulle {pageNumber} siirtyminen epäonnistui',
    nextPage: 'Seuraava sivu',
    notificationLoadFailed: 'Sivun lataaminen epäonnistui',
    notificationPublishFailed: 'Julkaisutyön lähettäminen epäonnistui',
    notificationSaveFailed: 'Sivun tallentaminen epäonnistui',
    notificationSaveSuccess: 'Sivu tallennettu onnistuneesti',
    pageOriginComposed: 'Koostuu useista PDF-sivuista',
    pageOriginExtracted: 'Poimittu yhdestä PDF-sivusta',
    pageOriginLabel: 'Sivun alkuperä',
    previousPage: 'Edellinen sivu',
    publishPageModalHelpText: 'Tämä osasivu julkaistaan kirjakontekstin ulkopuolella. Julkaiseminen luo uuden osasivun tai korvaa olemassa olevan sivun identiteettisääntöjen perusteella.',
    thumbnailCardTitle: 'PDF-sivun pikkukuva',
    viewBom: 'Osaluettelo (BOM)'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Luotu',
    columnPdfPage: 'PDF-sivu(t)',
    columnPublishingStatus: 'Julkaisun tila',
    detailLoadFailed: 'Julkaisutyön yksityiskohtien lataaminen epäonnistui',
    emptyBookOperations: 'Tässä työssä ei suoritettu kirjan toimintoja.',
    emptyJobsHint: 'Julkaisutoiminta näkyy tässä, kun sivut on julkaistu.',
    emptyJobsTitle: 'Tälle AI PDF -tuonnille ei ole vielä suoritettu yhtään julkaisutyötä.',
    emptyPagesTitle: 'Yksikään sivu ei vastaa valittua suodatinta.',
    filterAllPages: 'Näytä kaikki sivut',
    filterFailedOnly: 'Näytä vain epäonnistuneet sivut',
    filterNameQuery: 'Nimi tai sivutiedosto',
    filterPublishedOnly: 'Näytä vain julkaistut sivut',
    helpText: 'Tämä sivu näyttää tästä AI PDF -tuonnista julkaistujen osasivujen historian, mukaan lukien julkaisun aikana luodut, korvatut tai epäonnistuneet sivut.',
    jobLabel: 'Työ #{number}',
    loadFailed: 'Julkaisuhistorian lataaminen epäonnistui',
    resultPublishedCreated: 'Julkaistu – Luotu',
    resultPublishedUpdated: 'Julkaistu – Korvattu',
    resultSummaryBookCreated: 'Uusi kirja luotu.',
    resultSummaryNone: 'Sivuja ei julkaistu.',
    resultSummaryPagesFailed: '{n} sivu epäonnistui. | {n} sivua epäonnistui.',
    resultSummaryPagesPublished: '{n} sivu julkaistu. | {n} sivua julkaistu.',
    statusFailed: 'Epäonnistunut',
    statusInProgress: 'Meneillään',
    title: 'Julkaisuhistoria'
  },
  permission: 'Oikeus | Oikeudet',
  phoneNumber: 'Puhelinnumero',
  phoneNumberExt: 'Ulk.',
  phonePrimary: 'Ensisijainen Puhelinnumero',
  phoneSecondary: 'Toissijainen Puhelinnumero',
  pinFilter: 'Kiinteä suodatin tulossivujen hakua varten',
  pinned: 'Kiinnitetty',
  plusMoreOrgs: '+ {totalOrgCount} muuta Organisaatiota',
  polishDescription: 'Puola Kuvaus',
  polishName: 'Puola Nimi',
  populatePdfNameSelection: 'Täydennä PDF-tiedoston nimen valinta',
  populatePdfNameWith: 'Täydennä PDF-tiedoston tiedostonimi seuraavilla tiedoilla',
  port: 'Portti',
  portrait: 'Kuva',
  portugueseDescription: 'Portugali Kuvaus',
  portugueseName: 'Portugali Nimi',
  postComment: 'Lähetä Kommentti',
  postalCode: 'Postinumero',
  poweredBy: 'Voimanlähde:',
  preferences: 'Käyttäjäasetukset',
  preferencesDisable: 'Poista Käyttäjäasetukset Käytöstä',
  prefix: 'Etuliite | Etuliitteet',
  preview: 'Esikatselu',
  previewOfName: '{name} esikatselu',
  pricing: 'Hinnoittelu',
  pricingDiscountEnabled: 'Näytä Alennushinta',
  pricingDisplayInCart: 'Näytä Hinnat Ostoskorissa',
  pricingDisplayInPartsList: 'Näytä Hinnat Osaluettelossa',
  pricingGlobal: 'Yleinen Hinnoittelu',
  pricingGlobalDescription: 'Normaali hinta, kun Organisaation ohitusta ei ole',
  pricingHideInitially: 'Piilota hinta aluksi',
  pricingHidePricingButton: 'Ota Käyttöön Piilota Hinnoittelu -Painike',
  pricingHidePricingButtonDisable: 'Poista Käytöstä Piilota Hinnoittelu -Painike',
  pricingHidePricingButtonDisableHelp: '"Piilota hinnoittelu" -painikkeen poistaminen käytöstä poistaa käyttäjien mahdollisuuden näyttää/piilottaa hintatasoja. Mikä tahansa hintataso, joka on määritetty muotoon "Piilota hinta aluksi", pysyy piilotettuna eivätkä käyttäjät voi tuoda sitä näkyviin.',
  pricingOrganization: 'Organisaation Hinnoittelu',
  pricingOrganizationDeleteConfirm: 'Oletko varma, että haluat poistaa tämän Organisaation hinnoittelun?',
  pricingOrganizationDescription: 'Organisaation hinnoittelu ohittaa Organisaation ja sen Alaorganisaatioiden kaikkien käyttäjien yleisen hinnoittelun.',
  pricingOrganizationDuplicate: 'Tämä organisaatio on jo ohitettu',
  pricingOrganizationEmptyState: 'Organisaatioiden ohituksia ei ole määritetty. Aloita napsauttamalla {add}.',
  pricingRetailEnabled: 'Näytä Jälleenmyyntihinta',
  pricingWholesaleEnabled: 'Näytä Tukkuhinta',
  primary: 'Ensisijainen',
  print: 'Tulosta',
  printJob: 'Tulosta Työ',
  printLogo: 'Tulosta logo',
  printSetting: 'Tulostusasetus',
  printSettingCopyMessage: 'Anna uudelle Tulostusasetukselle yksilöllinen nimi.',
  printSettingCreated: 'Tulostusasetus luotu',
  printSettingDeleteFail: 'Tulostusasetuksen Poistaminen Epäonnistui',
  printSettingEmptyMessage: 'Tulostusasetuksia ei ole määritetty. Aloita Lisäämällä Tulostusasetus.',
  printSettingSaveFail: 'Tulostusasetuksen Tallentaminen Epäonnistui',
  printSettingSelectionRequired: 'Tulostusasetuksen valinta on pakollinen.',
  printSettingSetDefaultSuccess: 'Oletusarvoinen Tulostusasetussarja',
  printSettingUpdateFail: 'Tulostusasetuksen Päivittäminen Epäonnistui',
  printSettings: 'Tulostusasetukset',
  printSettingsLogo: 'Tulostusasetusten Logo',
  printerLane: 'Tulostinkaista',
  printing: 'Tulostus',
  printingDisabled: 'Poista Kaikki Tulostus Käytöstä',
  privacyPolicy: 'Tietosuojakäytäntö',
  proceed: 'Jatka',
  process: 'Edistyminen',
  processContent: 'Prosessin Sisältö',
  processToDraft: 'Käsitelty luonnokseksi',
  processedPlzToDraft: 'PLZ(:t) käsitelty luonnoksiksi',
  processing: 'Käsittely',
  productCategory: 'Tuotekategoria | Tuotekategoriat',
  productCategoryName: 'Tuotekategorian nimi',
  productId: 'Tuotetunniste',
  productIdErrorMessage: 'Tuotetunniste on pakollinen',
  productIdMessage: 'Tunnisteen arvo, jolla käyttäjät löytävät tuotteen, esim. "FTX1000"',
  productPage: 'Tuotesivu | Tuotesivut',
  productPageAccessControlDescription: 'Käyttöoikeudet määrittävät organisaatioiden ja käyttäjäryhmien nimeämisten perusteella, kenellä on oikeus nähdä tämä sivu.',
  productPageCreated: 'Tuotesivu luotu',
  productPageDescription: 'Tuotesivun kuvaus',
  productPageIdentifierMessage: 'Uniikki sisäinen tunniste tälle sivulle',
  productPageName: 'Tuotesivun nimi',
  productPageProductId: 'Tuotesivun tuotetunniste',
  productPageUpdated: 'Tuotesivu päivitetty',
  productPagesBulkImport: {
    description: 'Lataa datatiedostosi lähettääksesi tuotesivujen joukkotuonnin käsiteltäväksi. Tuettu tiedostomuoto: XLSX.',
    downloadUnprocessedRows: 'Lataa käsittelemättömien rivien taulukko',
    overwriteAccessControls: 'Korvaa käyttöoikeudet (organisaatiot ja käyttäjäryhmät)',
    overwriteAssociatedMedia: 'Korvaa liitetyt tiedostot',
    requirements: {
      enUSCategory: {
        description: 'Annetun aluekoodin (locale) olemassa oleva tuoteluokan nimi. Katso <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">kielitukioppaamme</a>.'
      },
      enUSDescription: {
        description: 'Kielikohtainen käännöskuvaus tuotesivulle. Katso <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">kielitukioppaamme</a>.'
      },
      enUSName: {
        description: 'Kielikohtainen käännösnimi tuotesivulle. Uusille tuotesivuille vaaditaan vähintään yksi käännös. Katso <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">kielitukioppaamme</a>.'
      },
      identifier: {
        description: 'Tuotesivun yksilöllinen tunniste, joka on katseltavissa ja haettavissa vain hallintakeskuksessa (Admin Center).'
      },
      media: {
        description: 'Luettelo tiettyyn tuotesivuun liittyvistä mediatunnisteista. Jos arvoja on useita, käytä erottimena merkkiä &#124;.'
      },
      organizations: {
        description: 'Luettelo organisaatioista, joilla on pääsy tietylle tuotesivulle. Jos arvoja on useita, käytä erottimena merkkiä &#124;.'
      },
      productId: {
        description: 'Tuotesivun tunniste loppukäyttäjille, katseltavissa ja haettavissa kirjastossa. Tuote-ID:n ei tarvitse olla yksilöllinen arvo.'
      },
      tagInternalName: {
        description: 'Määrittää tunnisteet (tagit) tuotesivulle. Otsikon on oltava tunnisteen sisäinen nimi. Jos arvoja on useita, käytä erottimena merkkiä &#124;. Esimerkki: Punainen &#124; Vihreä &#124; Sininen.'
      },
      thumbnail: {
        description: 'Pikkukuvan tiedostonimi. Sallitut tiedostopäätteet: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Luettelo käyttäjäryhmistä, joilla on pääsy tietylle tuotesivulle. Jos arvoja on useita, käytä erottimena merkkiä &#124;.'
      }
    },
    success: 'Tuotesivujen joukkotuontityö luotu',
    title: 'Tuotesivujen joukkotuonti'
  },
  production: 'Tuotanto',
  professional: 'Ammattilainen',
  profile: 'Profiili',
  prohibitExportDownloadOfContent: 'Kiellä sisällön vienti/lataus',
  prohibitExportDownloadOfContentHelpText: 'Asetus arvoon \'Ota käyttöön\' estää käyttäjiä (joilla on etuoikeudet) viedä tai ladata tätä sisältöä.',
  property: 'Ominaisuus | Ominaisuudet',
  province: 'Lääni/Alue',
  'public': 'Julkinen',
  publish: 'Julkaise',
  publishDocuments: 'Julkaise Asiakirjat',
  publishDraft: 'Julkaise Luonnos',
  publishThumbnailJob: 'Julkaise Esikatselukuva',
  publisher: 'Julkaisija | Julkaisijat',
  publisherJob: 'Julkaisutyö',
  publisherLane: 'Julkaisijan kaista',
  publisherManualLane: 'Julkaisijan manuaalinen kaista',
  publisherMessage: 'Sisällön luonti, hallinta ja tulostusasetukset',
  publishingErrors: 'Julkaisuvirheet',
  publishingErrorsWithName: 'Julkaisuvirheet {nimi}',
  publishingInProgress: 'Julkaisu on käynnissä, ei voi lähettää',
  purchaseOrder: 'Ostotilaus',
  purchaseOrderTemplateDisabled: 'Poista Tilausmallineett Käytöstä',
  purchaseOrderTemplateEnabled: 'Ota Tilausmallineet Käyttöön',
  qty: 'Määrä',
  quantity: 'Määrä',
  query: 'Kysely',
  quickAdd: 'Pikalisäys',
  quickAddHelpText: 'Aloita kirjoittaminen löytääksesi osat, jotka haluat lisätä ostoskoriin.',
  quickAddInCartEnabled: 'Ota Pikalisäys Käyttöön Ostoskorissa',
  quickLinks: 'Pikalinkit',
  quote: 'Tarjous | Tarjoukset',
  quoteFormType: 'Tarjouslomake',
  quoteTemplateDisabled: 'Poista Tarjousmallit Käytöstä',
  quoteTemplateEnabled: 'Ota Tarjousmallit Käyttöön',
  range: 'Alue',
  rearrange: 'Järjestä uudelleen',
  rebuildIndexJob: 'Kokoa Indeksi uudestaan',
  recentSearches: 'Uusimmat haut',
  recentlyAdded: 'Viimeksi Lisätty',
  recentlyEdited: 'Viimeksi Muokattu',
  recentlyViewed: 'Viimeksi Katsottu',
  recipientOrRecipients: 'Vastaanottaja(t)',
  rectangle: 'Suorakulmio',
  redirect: 'Ohjaa uudelleen',
  refresh: 'Päivitä',
  related: 'Liittyvä',
  relatedDescription: 'Kohteeseen {type} liittyvä kirjaston mediasisältö. Huomaa, että liittyvässä mediasisällössä tulee olla käyttöoikeuksien valvontaa, jotta käyttäjät voivat nähdä sen \'liittyvien\' välilehdessä.',
  relatedInfo: 'Liittyvät Tiedot',
  relatedView: 'Näytä Liittyvä Media',
  relationship: 'Suhde | Suhteet',
  releaseNotes: 'Julkaisutiedot',
  remainingWidth: 'Jäljellä Oleva Leveys',
  rememberMe: 'Muista minut',
  remove: 'Poista',
  removeAll: 'Poista Kaikki',
  removeItemConfirmation: 'Oletko varma, että haluat poistaa kohteen {item}?',
  removeItemCount: 'Haluatko varmasti poistaa {count} {type}?',
  replace: 'Vaihda',
  replaceExisting: 'Korvaa Olemassa Oleva',
  report: 'Raportti | Raportit',
  reportAnIssue: 'Ilmoita Ongelmasta',
  reportAnIssueMessage: 'Sähköpostin lähetys onnistui.',
  reportCatalogName: 'Raporttiluettelon nimi',
  reportCatalogNotSet: 'Raporttiluetteloa ei ole määritetty raportille.',
  reportDefinition: 'Raportin määritelmä | Raportin määritelmät',
  reportDefinitionDeleteError: 'Raporttiluetteloa ei ole määritetty raportille.',
  reportExportTimeWarning: 'Tietueiden lukumäärästä ja valitusta formaatista riippuen vienti voi kestää useita minuutteja.',
  reportSettings: 'Raporttiasetukset',
  reporting: 'Raportointi',
  reportingMessage: 'Pääsy eri raportteihin ja mittareihin',
  reportsEmptyState: 'Ei raportteja',
  reportsLibrary: 'Raporttikirjasto',
  requestForQuote: 'Hintapyyntö',
  requestFormType: 'Tarjouslomake',
  requireAuthentication: 'Vaadi Todennus',
  required: 'Pakollinen',
  requiredField: 'Pakollinen Kenttä',
  requiredItem: '{item} on pakollinen.',
  requiredMessage: '{item} on pakollinen.',
  requiredMessageAndUnique: '{item} on pakollinen ja sen on oltava yksilöllinen.',
  requiredReading: 'Vaatii Lukemisen',
  requiredReadingMessage: 'Tarkista seuraava:  ',
  requiredType: 'Tyyppi on pakollinen.',
  requiredUrlMessage: 'Oikein muodostettu URL on pakollinen.',
  reset: 'Palauta',
  resetPassword: 'Palauta Salasana',
  resetPasswordError: 'Salasanan palauttamisessa oli ongelmia, yritä myöhemmin uudelleen.',
  resetPasswordTokenError: 'Salasanan palautustunnus on virheellinen.',
  resetZoom: 'Palauta Zoomaus',
  resize: 'Muuta kokoa',
  resizeThumbnails: 'Muuta pikkukuvien koko automaattisesti',
  resource: 'Resurssi | Resurssit',
  result: 'Tulos | Tulokset',
  resultFor: 'Tulos kohteelle {item} | Tulokset kohteelle {item}',
  retail: 'Jälleenmyynti',
  retailPrice: 'Jälleenmyyntihinta',
  retailTotal: 'Jälleenmyynti Yhteensä',
  'return': 'Palaa',
  returnToItem: 'Palaa kohteeseen {item}',
  returnToMedia: 'Palaa Mediaan',
  returnToPartList: 'Palaa Osaluetteloon',
  returnToTemplate: 'Palaa Malliin',
  returnToViewer: 'Palaa katseluohjelmaan',
  revert: 'Palauta',
  revertChanges: 'Palauta Muutokset',
  revertChangesMsg: 'Haluatko varmasti palauttaa muutokset?',
  right: 'Oikea',
  romanianDescription: 'Romania Kuvaus',
  romanianName: 'Romania Nimi',
  rootLevelBrowseFlow: 'Juuritaso',
  row: 'Rivi',
  russianDescription: 'Venäjä Kuvaus',
  russianName: 'Venäjä Nimi',
  s3DataExportsEnabled: 'Ota käyttöön S3-datan viennit',
  sampleData: 'Näytedata',
  samplePreview: 'Näytteen esikatselu',
  sandbox: 'Sandbox',
  sat: 'La',
  save: 'Tallenna',
  saveAndClose: 'Tallenna ja sulje',
  saveAndEditTarget: 'Tallenna ja muokkaa kohdetta',
  saveChanges: 'Tallennatko muutokset kohteeseen {item}? {name}',
  saveChangesToItem: 'Tallennatko muutokset tähän kohteeseen {item}?',
  saveNewAPIKey: 'Uutta Integrointiavainta ei Tallennettu, Palaa viimeistelemään asennus',
  saveNewWidgetKey: 'Uutta widget-avainta ei tallennettu. Palaa täydellisiin asetuksiin.',
  saveOrderAttachmentsError: 'Tilauksen liitteiden tallentaminen epäonnistui.',
  saved: 'Tallennettu',
  search: 'Hae',
  searchAllContent: 'Hae kaikki sisältö',
  searchCategories: 'Kategoriat',
  searchConfiguration: 'Haun määritys',
  searchContent: 'Hae {content}',
  searchCriteria: 'Hakukriteerit',
  searchDocumoto: 'Hae Documoto',
  searchFeatures: 'Hakuominaisuudet',
  searchFieldConfigDescription: 'Seuraavat järjestelmäkentän hakuasetukset koskevat vain Kirjaston yleistä hakua, hakutulossivua ja Pikahakua ostoskorissa. Tämä ei vaikuta muihin hakutoimintoihin (kuten Hallintakeskuksen haku ja Kirjasto missä käytetty).',
  searchInContent: 'Hae kohdassa {contentName}...',
  searchPlaceholder: 'Hae kaikki sisältö...',
  searchPrompt: 'Hae kaikki sisältö...',
  searchProperty: 'Hakuominaisuus | Hakuominaisuudet',
  searchResults: 'Hakutulokset',
  searchResultsConfiguration: 'Hakutulosten määritys',
  searchSettings: 'Hakuasetukset',
  searchSettingsDescription: 'Nämä asetukset säätelevät kirjaston eri hakukäyttäytymisiä, -ominaisuuksia ja -tuloksia.',
  searchTerm: 'Hakusana',
  searchTips: 'Hakuvinkit:',
  searchType: 'Tyyppi',
  searchable: 'Haettavissa Oleva',
  searchableFieldsSuccessfullyUpdated: 'Hakukelpoiset kentät päivitetty onnistuneesti.',
  searchableTag: 'Haettavissa Oleva Tagi',
  searchingInLanguage: 'Haetaan vain kohdassa {lang} ',
  searchingInTwoLanguages: 'Haetaan vain kohdassa {lang1} ja {lang2} ',
  section: 'Osio',
  select: 'Valitse',
  selectAField: 'Valitse {field}',
  selectAll: 'Valitse Kaikki',
  selectAndClose: 'Valitse ja Sulje',
  selectChapters: 'Valitse Luku(-vut)',
  selectChildren: 'Valitse Alatasot',
  selectFields: 'Valitse {fields}',
  selectItem: 'Valitse {item}',
  selectMedia: 'Valitse Media',
  selectPage: 'Valitse Sivu',
  selectPages: 'Valitse Sivu(t)',
  selectTargetPage: 'Valitse Kohdesivu',
  selected: 'Valittu',
  selectedTargetPage: 'Valittu Kohdesivu',
  send: 'Lähetä',
  sendReverificationEmail: 'Lähetä uudelleentarkistussähköposti',
  sendVerificationEmail: 'Lähetä tarkistussähköposti',
  september: 'Syyskuu',
  sequence: 'Järjestys',
  serbianDescription: 'Serbia Kuvaus',
  serbianName: 'Serbia Nimi',
  serviceUri: 'Palvelun URI',
  sessionLog: 'Istuntoloki',
  set: 'Aseta',
  setAsDefault: 'Aseta Oletukseksi',
  setPassword: 'Aseta salasana',
  settings: 'Asetukset',
  settingsMessage: 'Päivitä käyttäjäasetukset ja salasana',
  shape: 'Muoto',
  shapeTool: 'Muototyökalu',
  shared: 'Jaettu',
  sharedCart: 'Jaettu Ostoskori | Jaetut Ostoskorit',
  sharedCartDeleteContent: 'Tämä poistaa tämän Jaetun Ostoskorin kaikista Organisaatioista, joissa se on jaettuna.',
  sharedCartOrganizationContent: 'Valitse Organisaatiot, jotka voivat käyttää tätä Jaettua Ostoskoria.',
  sharedShoppingCartsEnabled: 'Ota Jaetut Ostoskorit Käyttöön',
  shoppingCartExportJob: 'Ostoskorin Vienti',
  shoppingCartLoadingLongTime: 'Ostoskoria ladataan. Korin kuvakkeet tulevat käyttöön, kun prosessi on suoritettu. Jos ongelma jatkuu, pyydä apua Documoto-ylläpitäjältäsi.',
  showChapterTOCForHiddenPages: 'Näytä Piilotetut Sivut Kappaleen Sisällysluettelossa',
  showExportFromSearch: 'Salli Vienti Hakutuloksista',
  showExportFromSearchHelp: 'Salli hakutuloksena saadun kirjaluettelon vienti',
  showHelp: 'Näytä Ohjeet',
  showIdentifierInLibrary: 'Näytä median ja tuotesivun tunnisteet kirjastossa',
  showIdentifierInSearch: 'Näytä Mediatunniste haussa',
  showItem: 'Näytä {item}',
  showLess: 'Näytä Vähemmän',
  showMediaDescriptionFilter: 'Näytä Median Kuvauksen Suodatin',
  showMediaIdentifierFilter: 'Näytä Median Tunnisteen Suodatin',
  showMediaNameFilter: 'Näytä Median Nimen Suodatin',
  showMore: 'Näytä Enemmän',
  showOnlyExactMatches: 'Näytä vain tarkat osumat',
  showOrganizationFilter: 'Näytä Organisaation Suodatin',
  showPartNameFilter: 'Näytä Osan Nimen Suodatin',
  showPartNumberFilter: 'Näytä Osanumeron Suodatin',
  showRecentlyAdded: 'Näytä Viimeksi Lisätty',
  showRecentlyViewed: 'Näytä Viimeksi Katsottu',
  showSearchButton: 'Näytä Etusivun Hakupainike',
  showSearchButtonHelp: 'Näytä \'Siirry Hakuun\' -painike Kirjaston ylätunnisteessa',
  signature: 'Allekirjoitus',
  size: 'Koko',
  snapshot: 'Tilannekuva | Tilannekuvat',
  solrSlaveSvrOverride: 'SOLR-orjapalvelinten alustan URL:n päällekirjoitus',
  sortAsc: '{value} A-Z',
  sortDesc: '{value} Z-A',
  sortRelevant: 'Osuvin',
  sortType: 'Lajittelutyyppi',
  sourceBrowseFlow: 'Lähdeselailuprosessi',
  sourceFile: 'Lähdetiedosto',
  sourceFilename: 'Lähdetiedoston nimi',
  spanishDescription: 'Espanja Kuvaus',
  spanishName: 'Espanja Nimi',
  square: 'Neliö',
  ssoConfiguration: 'SSO-konfigurointi',
  ssoIdpMetadataUrl: 'SSO IDP Metadata URL',
  ssoLoginMaxAuthenticationAgeSeconds: 'SSO-kirjautumisen maksimitodennusikä sekunneissa',
  ssoSamlDnAttributeName: 'SSO SAML DN -määritenimi',
  ssoSamlEmailAttributeName: 'SSO SAML Email -määritenimi',
  ssoSamlMemberofAttributeName: 'SSO SAML MemberOf -määritenimi',
  ssoSniForSsoMetadataRetrieval: 'Käytä SNI SSO:ta Metadata -haulle',
  standard: 'Vakio',
  standardUserGroup: 'Vakiokäyttäjäryhmä',
  startDate: 'Aloituspäivä',
  startDateRequired: 'Aloituspäivämäärä vaaditaan.',
  state: 'Osavaltio',
  'static': 'Staattinen',
  status: 'Tila',
  statusCode: 'Tilakoodi | Tilakoodit',
  stitchPages: 'Nidontasivut',
  storeFilterValues: 'Tallenna suodatinarvot',
  storeFilterValuesDescription: 'Tämän asetuksen ottaminen käyttöön tallentaa arvot, jotka käyttäjät ovat asettaneet hakusivun suodattimiin tälle tunnisteelle.',
  storeFrontAdmin: 'Julkisivun Hallinta',
  storefront: 'Julkisivu',
  storefrontIntegration: 'Julkisivun Integrointi | Julkisivun Integroinnit',
  storefrontIntegrationSubtitle: 'Näillä asetuksilla hallitaan Julkisivun Integroinnin eri elementtejä ja vaihtoehtoja. Tee muutokset huolella. Ota yhteyttä Documoton Tukeen lisätietojen saamiseksi.',
  storefrontSettings: 'Julkisivuasetukset',
  storefrontSettingsDescription: 'Näillä asetuksilla hallitaan Julkisivun eri elementtejä ja vaihtoehtoja. Tee muutokset huolella. Ota yhteyttä Documoton Palveluihin lisätietojen saamiseksi.',
  storefrontSettingsOrgDescription: 'Näillä asetuksilla hallitaan Organisaatiotasoisia Julkisivun elementtejä ja vaihtoehtoja. Tee muutokset huolella. Ota yhteyttä Documoton Palveluihin lisätietojen saamiseksi.',
  stroke: 'Viiva',
  style: 'Tyyli | Tyylit',
  styles: {
    colorHotpoint: 'Hotpoint-oletus',
    inheritedFromOrg: 'Peritty organisaatiosta {org}',
    inheritedFromSystem: 'Peritty järjestelmän oletuksesta',
    inheritedFromTenant: 'Peritty vuokralaiselta',
    invalidHexcode: 'Virheellinen heksakoodi',
    organization: 'Organisaatiotyyli | Organisaatiotyylit',
    organizationSaved: 'Tallennetut organisaatiotyylit',
    sampleNavigation: 'Navigointivälilehdet',
    samplePrimary: 'Navigointi/Painikkeet',
    sampleSelectedHotpoint: 'Valitut hotpointit',
    tenant: 'Vuokralaisen tyyli | Vuokralaisen tyylit',
    tenantSaved: 'Tallennetut vuokralaisen tyylit'
  },
  subChapter: 'Alakappale | Alakappaleet',
  subject: 'Otsikko',
  subjectMessage: 'Otsikko on pakollinen',
  submit: 'Lähetä',
  submitPurchaseOrder: 'Ostotilaus',
  submitRequestForQuote: 'Hintapyyntö',
  submitted: 'Lähetetty',
  submittedBy: 'Lähettäjä: ',
  submittedFilesMessage: 'Lähetettiin {fileCount} tiedosto(a).',
  submitter: 'Lähettäjä',
  submitterEmail: 'Lähettäjän sähköpostiosoite',
  submitterFirstName: 'Lähettäjän etunimi',
  submitterLastName: 'Lähettäjän sukunimi',
  submitterOrgName: 'Lähettäjän organisaation nimi',
  submitterUserName: 'Lähettäjän käyttäjänimi',
  success: 'Onnistui',
  successNotificationDuration: 'Lisää Ostoskärryyn - Onnistuneen Toast -ilmoituksen Kesto',
  suffix: 'Jälkiliite | Jälkiliitteet',
  suggestedKeywords: 'Ehdotetut hakusanat',
  suggestedResults: 'Ehdotetut tulokset',
  suggestion: 'Ehdotus | Ehdotukset',
  sun: 'Su',
  superAdminSettings: 'Pääylläpitäjän asetukset',
  superadmin: 'Pääylläpitäjä',
  supersede: 'Korvaa',
  supersedeComplete: 'Haluatko suorittaa korvaamisen?',
  supersedeDiscardChanges: 'Hylkää korvaaminen?',
  supersedeMainText: 'Tämä korvaa olemassa olevan osan yhdellä tai useammalla osalla kaikilla Osien Sivuilla, joista vanha osa löytyy. Vanha osanumero poistetaan, mutta sitä voi edelleen hakea tagien avulla, joten sisältö löytyy käyttämällä vanhaa numeroa tai uutta numeroa (uusia numeroita).',
  supersedeMessage: 'Osat päivittyvät välittömästi. Haku vastaa päivityksiä muutaman minuutin kuluessa.',
  supersedeNotProcessed: 'Korvaamista ei käsitellä.',
  supersedeReplacePart: 'Hae yhtä tai useampaa osaa, joka korvaa osan',
  supersedeSuccessful: 'Korvaaminen Onnistui',
  supersedeWith: 'Korvaa Osa Seuraavalla...',
  superseded: 'Korvattu',
  supersededParts: 'Korvatut osat',
  supplier: 'Toimittaja | Toimittajat',
  supplierDescription: 'Yritys, joka toimittaa tämän osan',
  supplierKey: 'Toimittajan avain',
  supportedDraftArchives: 'Ei-tuettu tiedosto; tuetut luonnostiedostot: MDZ, PLZ',
  supportedImageFormats: 'Tuetut kuvamuodot: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Merkitse useampi hakusana lainausmerkeillä saadaksesi tarkat vastaavuudet.',
  svgFinder: 'SVG-haku',
  swedishDescription: 'Ruotsi Kuvaus',
  swedishName: 'Ruotsi Nimi',
  system: 'Järjestelmä',
  systemAdmin: 'Järjestelmän Hallinta',
  systemFieldSearchAndFiltering: 'Järjestelmäkenttien haku ja suodatus',
  systemFields: 'Järjestelmäkentät',
  systemName: 'Järjestelmän nimi',
  systemStatus: 'Järjestelmän Tila',
  systemVersion: 'Järjestelmäversio',
  tabDelimited: 'Välilehdellä erotettu',
  tableOfContents: 'Sisällysluettelo',
  tabloid: 'Tabloidi',
  tag: 'Tagi | Tagit',
  tagDeleteAffectedCount: 'Tämä poistaa tagin ja tagin tiedot {count} kohteesta.',
  tagDeleteAffectedNone: 'Yksikään kohde ei tällä hetkellä käytä tätä tagia.',
  tagEditor: {
    filterPrompt: 'Näytetään ensimmäiset 100 arvoa. Käytä suodatinta nähdäksesi lisää.',
    rangeBoundLengthInvalid: 'Rajassa voi olla korkeintaan {limit} numeroa.',
    tagEditorModal: 'Tagieditorin Muoto',
    textfieldHelpText: 'Syötä yksi tai useampia arvoja puolipisteellä eroteltuna. Esimerkki: SN001; SN002'
  },
  tagManagerDeleteWarning: 'Kaikki olemassa olevat mediat, joilla on {deleteCategoryName}, menettävät tämän kategorian poistamisen jälkeen.',
  tagName: 'Tunnisteen nimi',
  tagSearchAndFiltering: 'Tunnisteiden haku ja suodatus',
  tagSearchAndFilteringHelpText: 'Vihje: Jotkin haku- ja suodatinasetukset ovat määritettävissä myös Tag Managerin tunnisteiden muokkaajissa, jotka löytyvät täältä: ',
  tagSubmitAffected: 'Mikä tahansa tyypin {type} sisältö pudottaa automaattisesti tagin {tag} muutosten lisäksi.',
  tagValue: 'Tagin Arvo | Tagien Arvot',
  tagValueMissing: 'Sinun on annettava tagin arvo',
  tagValueMultiple: 'Puolipiste erottaa eri syötteet',
  tagValueTooLong: 'Tagin arvo ylittää 25 merkin rajan | Tagien arvot ylittävät 25 merkin rajan',
  tagsDeleteError: 'Yhtä tai useampaa tagia ei voitu poistaa',
  tagsDeleteSuccess: 'Tagien poisto onnistui',
  tagsDisplayMore: 'Näytetään ensimmäiset 100 arvoa. Käytä suodatinta nähdäksesi lisää.',
  tagsManager: 'Tagien Hallintatoiminto',
  tagsSaveError: 'Yhtä tai useampaa tagia ei voitu tallentaa',
  tagsSaveSuccess: 'Tagien tallennus onnistui',
  tagsUpdateError: 'yhden tai useamman tagin päivitys epäonnistui',
  tagsUpdateSuccess: 'Tagien päivitys onnistui',
  targetBrowseFlow: 'Kohdeselailuprosessi',
  taxon: 'Luokka',
  taxonomy: 'Luokitus',
  template: 'Malli | Mallit',
  templateEmailRecipients: 'Sähköpostimallin Vastaanottajat',
  templateLayout: {
    addItem: 'Lisää kohde',
    addRow: 'Lisää rivi',
    deleteColumn: 'Poista sarake',
    deleteRow: 'Poista rivi',
    fullWidth: 'Täysleveä',
    oneColumn: 'Yksi sarake',
    threeColumns: 'Kolme saraketta',
    twoColumns: 'Kaksi saraketta'
  },
  tenant: 'Tenant | Tenants',
  tenantAdmin: 'Tenant-ylläpitäjä',
  tenantAdminMessage: 'Hallitsee tenant-laajuisia asetuksia',
  tenantCleanerJob: 'Tenantin Ylläpito',
  tenantConfiguration: 'Vuokraajan konfigurointi',
  tenantEmailRecipients: 'Tenant-sähköpostin Vastaanottajat',
  tenantEmailRecipientsOverrideMessage: 'Nämä ohitetaan, jos Organisaation Sähköpostin Vastaanottajat määritetään',
  tenantIndexQueueJob: 'Tenantin Indeksijono',
  tenantKey: 'Vuokraajan avain',
  tenantKeyError: 'Vuokraajan avain ei ole uniikki',
  tenantKeyMessage: 'Vuokraajan avaimen on oltava uniikki',
  tenantLabelDeleteMessage: 'Tämän nimityksen poistaminen palauttaa Documoton oletusnimen.',
  tenantLabelsPageText: 'Nimityksiä käytetään Documoton Kirjastossa ja Hallintanäytöillä esiintyvien monien objektien nimien mukauttamiseen.',
  tenantPrintSettingsDescription: 'Valitse Tenant-laajuinen oletustulostusasetus. Tätä käytetään kaikessa kirjojen tulostuksessa, ellei ohitettu Organisaatiossa tai Mediassa.',
  tenantReindexModulus: 'Vuokraajan uudelleenindeksoinnin moduuli',
  tenantSettings: {
    collapseTOCLabel: 'Tiivistä Sisällysluettelo Yhdistämissivulla',
    defaultLocaleLabel: 'Oletuskieliasetus',
    defaultLocaleMessage: 'Tenant-oletuskieliasetus.',
    defaultSupplierLabel: 'Oletustoimittaja',
    defaultSupplierMessage: 'Tenant-oletustoimittaja.',
    deleteMissingTranslationsOnPublishLabel: 'Poistetaanko puuttuvat käännökset julkaisusta?',
    deleteMissingTranslationsOnPublishMessage: 'Ota käyttöön osan käännösten poistaminen julkaisusta',
    enableChapterIndexingLabel: 'Käynnistää Mediakappaleiden hakemistonluonnin',
    enableChapterIndexingMessage: 'Tee kappalehakemistot',
    enableIndexingLabel: 'Julkaisujen indeksointi',
    enableIndexingMessage: 'Kytkee julkaisujen indeksoinnin päälle.',
    excludePartsFromAccessControlChecksLabel: 'Sulje osat pois käyttöoikeussäännöistä',
    excludePartsFromAccessControlChecksMessage: 'Kun tämä on käytössä, osat ovat näkyvissä kaikille käyttäjille mediakohtaisista käyttöoikeusrajoituksista riippumatta.',
    exportPgAsHashLabel: 'Vie sivutiedoston nimi ristikkonäppäimenä',
    exportPgAsHashMessage: 'Käytä sivun ristikkonäppäimiä sivun tiedoston niminä vientisisällössä',
    helpUrlLabel: 'Oletusohjeen URL',
    helpUrlMessage: 'Vaihtoehtoisen ohjejärjestelmän URL.',
    hotPointLinkPageInBookOnlyLabel: 'Sivun pikanäppäinlinkit vain kirjassa',
    hotPointLinkPageInBookOnlyMessage: 'Pikalinkit vain kirjan sivuilta',
    lockPartTrOnPublishLabel: 'Lukitse osan käännökset julkaisussa',
    lockPartTrOnPublishMessage: 'Estää osan käännösten muokkaamisen julkaisun aikana',
    mediaTimestampLabel: 'Päivitä Median Aikaleima Käyttöoikeuksien Muutoksen Yhteydessä',
    mediaTimestampMessage: 'Ota käyttöön, jos kulunvalvontamedialuokkien muutoksen pitäisi päivittää median aikaleima.',
    publisherDefaultUom: 'Julkaisijan Oletusarvoinen UOM',
    publishingContactLabel: 'Yhteyssähköpostin Julkaiseminen',
    publishingContactMessage: 'Oletussähköpostiosoite, joka vastaanottaa sisältöongelmista raportoivia sähköposteja.',
    replaceHotpointLabel: 'Korvaa Aina Kohdepistelinkit Julkaistaessa',
    replaceHotpointMessage: 'Koskee vain Docustudio-julkaisua.',
    ssoLoginSystemLabel: 'SSO-kirjautumisjärjestelmä',
    ssoLoginSystemMessage: 'Tunnistetietojen toimittajan SSO-järjestelmä.',
    userPasswordExpirationLabel: 'Käyttäjän salasanan umpeutumispäivät',
    userPasswordExpirationMessage: 'Päivien määrä, jonka jälkeen salasanat on nollattava; jätä tyhjäksi, jos haluat että salasana ei umpeudu koskaan'
  },
  tenantSettingsSaved: 'Vuokralaisen Asetukset Tallennettu',
  tenantSettingsSubtitle: 'Nämä asetukset hallitsevat vuokralaisen laajuisia ominaisuuksia ja käyttäytymistä. Ole varovainen tehdessäsi muutoksia. Ota yhteys Documoto Palveluun lisätietoja varten.',
  tenantSettingsTitle: 'Vuokralaisen Asetukset',
  tenantSuppliers: 'Vuokraajan toimittajat',
  tenantType: 'Vuokraajatyyppi',
  tenantWebserviceUser: 'Vuokraajan verkkopalvelukäyttäjä',
  text: 'Teksti',
  textArea: 'Tekstialue',
  textColor: 'Tekstin väri',
  textField: 'Tekstikenttä',
  textFile: 'Tekstitiedosto (CSV, TXT)',
  textTool: 'Tekstityökalu',
  threeD: {
    addFile: 'Lisää 3D-osatiedosto',
    beforeSaveModal: {
      message: 'Haluatko korvata tämän tiedoston kaikkialla, jossa se on olemassa, tai liittää sen vain tähän osaan? Jos haluat korvata tiedoston, tapahtuu seuraavaa:',
      messageBulletOne: '{count} osa(t) päivitetään tällä uudella CAD-tiedostolla',
      messageBulletOneForContent: '{count} {contentType} päivitetään tällä uudella CAD-tiedostolla',
      messageBulletTwo: 'Tämän tiedoston aiempi versio poistetaan Documoton tiedostojärjestelmästä',
      tip: 'Vinkki: Välttyäksesi tiedostojen ylikirjoittamiselta liitosprosessin aikana voit muuttaa liittämäsi tiedoston nimen ennen sen tuontia.',
      title: 'CAD-tiedosto on jo olemassa Documotossa tällä tiedostonimellä.'
    },
    deleteTitle: 'Haluatko varmasti poistaa tämän 3D-näkymän?',
    drawMode: {
      hiddenLines: 'Piilotetut rivit',
      label: 'Piirrostila',
      shaded: 'Varjostettu',
      wireframe: 'Wireframe',
      wireframeShaded: 'Wireframe varjostettu'
    },
    explode: 'Levitä',
    failureCreatingBomAssociations: '3D-mallin BOM-assosiaatioiden luomisessa tapahtui virhe.',
    fileSizeModal: {
      message: 'Documoton sallittu tiedoston enimmäiskoko on 25 megatavua. Tiedosto, jota yrität ladata, on ylittänyt enimmäismäärän, eikä sitä voi ladata. Jatka napsauttamalla ”OK”.',
      title: 'Tiedoston enimmäiskoko ylitetty'
    },
    fileSizeModalWarning: {
      message: 'Documotossa sallittu erillisen tiedoston enimmäiskoko on {size} megatavua. Yksi tiedostoista, joita yrität ladata, ylittää sallitun enimmäiskoon eikä sitä voida ladata. Jatka näpäyttämällä ”OK”.',
      title: 'Tiedoston enimmäiskoko ylitetty'
    },
    freeTierCurrentCount: 'Sinulla on {count} aktiivista ilmaisen tason 3D-mallia käytössä 15:stä. Kun saavutat rajan, et voi enää julkaista uusia sivuja, joissa on 3D-malleja. Ota yhteyttä Customer Success Manageriisi päivittääksesi tilauksesi.',
    freeTierExceededError: 'Tämän sivun julkaiseminen 3D-mallin kanssa ei ole sallittua.',
    freeTierExceededOption1: 'Ota yhteyttä Customer Success Manageriisi päivittääksesi tilauksesi.',
    freeTierExceededOption2: 'Poista 3D-malli sivuluonnoksesta julkaistaksesi sen.',
    freeTierExceededTitle: 'Olet ylittänyt 15 aktiivisen 3D-mallin rajan',
    illustrationLabel: '2D-näkymä',
    invalidFile: 'Virheellinen tiedosto lähetetty ladattavaksi',
    mapModelToBom: 'Karttamalli BOM:iin',
    modelLabel: '3D-malli',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: '3D-mallin osanumeroita vastaavia BOM-osia ei löytynyt',
    noPartsMatchRegEx: 'Yksikään BOM-osa ei vastaa säännöllistä lauseketta',
    orientation: 'Suunta',
    orientationAndProjection: {
      back: 'Takaisin',
      bottom: 'Alhaalla',
      front: 'Edessä',
      isometric: 'Isometrinen',
      left: 'Vasen',
      orthographic: 'Ortografinen',
      perspective: 'Perspektiivi',
      projection: 'Projisointi',
      right: 'Oikea',
      top: 'Ylhäällä'
    },
    partNumberProperty: 'Osanumeron ominaisuus',
    partNumberRegex: 'Osanumeron säännöllinen lauseke',
    partNumbersInModel: 'Osanumerot mallissa',
    resetCamera: 'Nollaa kamera',
    setAsDefaultView: 'Aseta oletusnäkymäksi',
    setAsDefaultViewTooltip: 'Aseta tämä suunta ja suurennostaso oletusaloitusnäkymäksi.',
    slice: {
      label: 'Osuus',
      planeX: 'Leikkaustaso X',
      planeY: 'Leikkaustaso Y',
      planeZ: 'Leikkaustaso Z',
      reset: 'Leikkaustason nollaus',
      section: 'Leikkaustason osion vaihto',
      visibility: 'Leikkaustason näkyvyyden vaihto'
    },
    successfullyCreatedBomAssociations: '{count} 3D-mallin BOM-assosiaatioiden luonti onnistui',
    successfullySavedDefaultView: 'Oletusnäkymän tallennus onnistui',
    supportedFilesMessage: 'Documoto tukee monia CAD-tiedostoformaatteja. Kysy lisää tukikeskuksesta, jos haluat tietää, onko CAD-tiedostoformaattisi tuettu.',
    threeD: '3D',
    toolsLabel: '3D-työkalut',
    topAssemblyFilename: 'Yläkokoonpanon tiedostonimi',
    topAssemblyFilenameInvalid: 'Ylätason kokoonpanotiedosto ei ole tiedostoluettelossa',
    topAssemblyFilenameRequired: 'Yläkokoonpanon tiedostonimi on pakollinen',
    viewerControls: 'Viewerin hallinta',
    viewerSettings: '3D Viewerin asetukset',
    viewerTitle: '3D-katseluohjelma'
  },
  thu: 'To',
  thumbnail: 'Esikatselukuva',
  thumbnailDeleted: 'Esikatselukuvan Poisto Onnistui',
  thumbnailDeletedError: 'Esikatselukuvan Poisto Epäonnistui',
  thumbnailReapplyWarning: 'Järjestelmä voi ottaa esikatselukuvan uudelleen käyttöön median sisällöstä riippuen. Tämä voi kestää muutaman minuutin.',
  thumbnailResizeTooltip: 'Muuttaa pikkukuvat enintään 500x500 pikseliin, jos valittu',
  thumbnailUpdated: 'Esikatselukuvan Päivitys Onnistui',
  thumbnailUpdatedError: 'Esikatselukuvan Päivitys Epäonnistui',
  title: 'Otsikko',
  to: 'Päättyen',
  toDate: 'Päättymispäivä',
  toGetStarted: 'ja aloita.',
  toastNotifications: 'Toast -ilmoitukset',
  toc: 'Sisällysluettelo',
  tocClipBoardSuccessTitle: 'Kopioitu Leikepöydälle',
  tocClipBoardWarningText: 'VAROITUS: Et voi kopioida tallentamattomia muutoksia leikepöydälle',
  tocClipBoardWarningTitle: 'Kopioitu Leikepöydälle',
  tocDisplayingFirstValues: 'Näytetään ensimmäiset 100 arvoa. Käytä suodatinta nähdäksesi lisää.',
  tocDuplicateWarningText: 'Kappaleesta löytyi sama sivu kahteen kertaan. Kaksoiskappale poistettiin.',
  tocEmptyMessage: 'Et ole vielä luonut Sisällysluetteloa',
  tocMissingChapterName: 'Kappaleen Nimi Puuttuu',
  tocModalTableCaption: 'Tagieditorin Muoto',
  tocNothingSelected: 'Ei Mitään Valittuna',
  tocOpenEditor: 'Avaa Editori',
  tocSaveRequired: 'Tallennettava ennen kappaleen tietojen muokkaamista',
  tocState: 'Sisällysluettelon Alustava Tila',
  tocThumbnailDeleteFailTitle: 'Esikatselukuvan Poisto Epäonnistui',
  tocThumbnailDeleteSuccessTitle: 'Esikatselukuvan Poisto Onnistui',
  tocThumbnailUploadFailTitle: 'Esikatselukuvan Lataus Epäonnistui',
  tocThumbnailUploadSuccessTitle: 'Esikatselukuvan Lataus Onnistui',
  tocTranslationMessage: 'Tämän kappaleen nimi ja valinnainen kuvaus',
  tocUntitledPage: 'Otsikoimaton Sivu',
  togglePage: 'Vaihtele Sivua',
  tooManySelections: 'Luettelo ylittää valintarajan: {limit}',
  top: 'Ylös',
  total: 'Yhteensä',
  totalItems: 'Tuotteita Yhteensä',
  translation: 'Käännös | Käännökset',
  translationHelpTextItem: 'Tämän kohteen {item} nimi ja valinnainen kuvaus',
  'true': 'Totta',
  tryAgain: 'Yritä uudelleen.',
  trySearchingToc: 'Kokeile hakea mitä tahansa näkemääsi tai muistamaasi sanaa — luettelo kaventuu välittömästi. Näkymä ei muutu ennen kuin klikkaat tulosta.',
  tryThis: 'Kokeile tätä',
  tue: 'Ti',
  turkishDescription: 'Turkki Kuvaus',
  turkishName: 'Turkki Nimi',
  twoSided: 'Kaksipuolinen',
  type: 'Tyyppi | Tyypit',
  typeAtLeastTwoChars: 'Kirjoita vähintään 2 merkkiä nähdäksesi luettelon vastaavuuksista.',
  typeSearchCriteriaAlreadySet: 'Poista valittu “Tyyppi”-hakukriteeri ottaaksesi muutokset käyttöön.',
  typeToConfirm: 'Kirjoita {value} vahvistaaksesi',
  typography: 'Typografia',
  ukraineDescription: 'Ukraina Kuvaus',
  ukraineName: 'Ukraina Nimi',
  unableToRetrieveResults: 'Kyselyn/haun tuloksia ei voida hakea',
  unauthorized: 'Ei lupaa',
  unknownError: 'Tuntematon virhe, ota yhteyttä Documoton tukeen osoitteessa support{\'@\'}documoto.com lisätietojen saamiseksi.',
  unknownInput: 'Tuntematon syöttötyyppi:',
  unknownPart: 'Tuntematon Osa',
  unknownType: 'Tuntematon tyyppi',
  unsavedAPIKeyWarning: 'API-avaimesi katoaa, jos et Palaa',
  unsavedChanges: 'Sinulla on tallentamattomia muutoksia. Jatkatko?',
  unsavedChangesWarning: 'Muutoksesi häviävät, ellet tallenna niitä.',
  unsavedWidgetKeyWarning: 'Widget-avaimesi menetetään, jos et palaa.',
  unsupportedBrowserMessage: 'Suunnittelimme tämän sovelluksen viimeisimmällä teknologialla. Se tekee sovelluksesta entistä nopeamman ja helppokäyttöisemmän. Valitettavasti selaimesi ei tue näitä teknologioita.',
  untitledOrg: 'Nimetön Organisaatio',
  unverified: 'Vahvistamaton',
  uom: 'MY',
  update: 'Päivitä',
  updateFailed: 'Päivitys epäonnistui',
  updateIndex: 'Päivitä Hakemisto',
  updatePassword: 'Päivitä Salasana',
  updatePasswordMessage: 'Salasanan päivitys onnistui',
  updatePasswordPending: 'Salasanan vaihto odottaa tallennusta.',
  updated: 'Päivitetty',
  upgradeBrowser: 'Päivitä selaimesi.',
  upload: 'Lataa',
  uploadComplete: 'Lataus Valmis',
  uploadFileSizeLimitExceeded: 'Tiedosto ylittää kokorajoituksen sovelluksen sisäisene katselemiseen.',
  uploadInProgress: 'Lataus Käynnissä',
  uponSavingDisabledTenant: 'Kun olet tallentanut tämän sivun tämä asetus käytössä, tapahtuu seuraavaa:',
  uponSavingThisLicense: 'Kun olet tallentanut tämän sivun tällä asetuksella, sinun ON TEHTÄVÄ SEURAAVAA:',
  upperBound: 'Yläraja',
  usCurrency: 'USD',
  useDefaultCartColumns: 'Käytä Ostoskorin Oletussarakkeita',
  useDefaultPartsListColumns: 'Käytä Osaluettelon Oletussarakkeita',
  useSequentialPageNumbering: 'Käytä Peräkkäistä Sivunumerointia',
  useSniForSsoMetadataRetrieval: 'Käytä SNI SSO:ta Metadata -haulle',
  user: 'Käyttäjä',
  userAddress: 'Käyttäjän Osoitteet | Käyttäjien Osoitteet',
  userCount: 'Käyttäjämäärä',
  userEditable: 'Käyttäjän Muokattavissa',
  userExpirationDate: 'Käyttäjän viimeinen käyttöpäivä',
  userExpirationDateInvalid: 'Käyttäjän voimassaolon päättymispäivä annettava',
  userGroup: 'Käyttäjäryhmä | Käyttäjäryhmät',
  userGroupEmpty: 'Käyttäjäryhmät eivät voi olla tyhjiä',
  userGroupType: 'Käyttäjäryhmän tyyppi',
  userGroupUniqueMessage: 'Tämän nimen on erotuttava kaikista muista tämän tenant Käyttäjäryhmien nimistä.',
  userGroupUsers: 'Käyttäjäryhmän Käyttäjät',
  userSettings: 'Käyttäjäasetukset',
  userVerificationEmailBody: 'Käyttäjän tarkistussähköpostin runko',
  userVerificationEmailFieldsValidation: 'Käyttäjän tarkistussähköpostin kenttien on oltava molempien joko tyhjiä tai täytettyjä',
  userVerificationEmailSubject: 'Käyttäjän tarkistussähköpostin otsikko',
  username: 'Käyttäjätunnus',
  usernameEmpty: 'Käyttäjätunnus ei voi olla tyhjä',
  users: 'Käyttäjät',
  usersWillReceiveAnUnauthorizedError: 'Käyttäjät saavat ”Ei lupaa” -virheviestin, kun he yrittävät kirjautua vuokralaisen sivulle.',
  validate: 'Vahvista',
  validateTenantDirectories: {
    buttonLabel: 'Vahvista sisältöhakemistot',
    error: 'Hakemistojen vahvistus epäonnistui',
    success: 'Vahvistetut vuokraajahakemistot'
  },
  validationMessage: 'Validointiviesti | Validointiviestit',
  value: 'Arvo',
  valueGteError: 'Arvon on oltava pienempi tai sama kuin {max}',
  valueLteError: 'Arvon on oltava suurempi tai sama kuin {min}',
  variantSKU: 'SKU-Variantti',
  vendorName: 'Toimittajan nimi',
  verificationEmailRequested: 'Tarkistussähköposti lähetetään tallennettavaksi.',
  verificationEmailSent: 'Tarkistussähköposti lähetetty. Salasanaa ei ole asetettu.',
  verified: 'Vahvistettu',
  verifyPassword: 'Vahvista Salasana',
  verifying: 'Vahvistetaan',
  version: 'Versio',
  vertical: 'Vertikaalinen',
  video: 'Video | Videot',
  view: 'Näytä',
  viewAll: 'Näytä kaikki',
  viewAllPagesAndBooks: 'Näkymä: Kaikki sivut ja kirjat',
  viewAllResults: 'Näytä kaikki tulokset',
  viewBooks: 'Näkymä: Kirjat',
  viewModeList: 'Listanäkymä',
  viewModeTable: 'Taulukkonäkymä',
  viewMore: 'Näytä enemmän',
  viewPages: 'Näkymä: Sivut',
  viewWhereUsed: 'Katso missä käytetty',
  views: 'Näkymät',
  visibility: 'Näkyvyys',
  visibilityDescription: 'Kenen nähtävissä tämä {entity} on',
  visible: 'Näkyvillä',
  waitForUpload: 'Odota, kunnes lataus on valmis.',
  watermark: 'Vesileima',
  watermarkFont: 'Vesileiman fontti',
  watermarkOpacityPercentage: 'Vesimerkin läpinäkyvyys %',
  watermarkOrientation: 'Vesileiman suuntaus',
  watermarkSaveFailed: 'Vesileiman tallentaminen epäonnistui.',
  watermarkSaved: 'Vesileima tallennettu',
  watermarkSelectionRequired: 'Tunnuksen tai tekstin valinta vaaditaan.',
  watermarkText: 'Vesileiman teksti',
  wed: 'Ke',
  whereUsed: 'Missä Käytetty',
  whereUsedCountInSearchBar: 'Missä käytetty -määrä hakupalkissa',
  whoCanViewComment: 'Kuka voi nähdä tämän kommentin?',
  wholesale: 'Tukku',
  wholesalePrice: 'Tukkuhinta',
  wholesaleTotal: 'Tukku Yhteensä',
  widget: 'Widgetti',
  widgetAuthHeader: 'Widgetin valtuutusarvo',
  widgetErrorConfig: 'Widgetiä ei voitu alustaa virheellisen widget-määritelmän vuoksi',
  widgetErrorInit: 'Documoto-widgetin alustaminen epäonnistui',
  widgetErrorLocation: 'Määritetyn sisällön paikannus epäonnistui widgetissä',
  widgetErrorMultipleLocations: 'Määritetylle sisällölle löytyi useita sijainteja',
  widgetKey: 'Widget-avain | Widget-avaimet',
  widgetKeyAdmin: 'Widget-avaimen hallinta',
  widgetKeyCopied: 'Widgetin valtuutusarvo kopioitu leikepöydälle',
  widgetKeyDeleteMsg: 'Widget-avaimen poistaminen estää sen käytön',
  widgetKeyDeleted: 'Widget-avain poistettu',
  widgetKeyDeletedError: 'Virhe poistettaessa widget-avainta',
  widgetKeyManager: 'Widget-avainten hallintar',
  widgetKeyNameEmpty: 'Nimen on oltava yksilöllinen ja se vaaditaan. Tätä arvoa käytetään myös raportointi- ja lokitarkoituksiin widgetin toiminnan käyttäjänimenä',
  widgetKeyRegenError: 'Virhe Widget-avaimen uudelleenluomisessa',
  widgetKeyRegenMsg: 'Tämän widget-avaimen uudelleenluominen voi poistaa olemassa olevat integraatiot käytöstä',
  widgetKeyRegenTitle: 'Oletko varma, että haluat luoda tämän Widget-avaimen uudelleen?',
  widgetKeySaved: 'Widget-avain tallennettu',
  widgetPermissions: 'Widget-käyttäjillä on vain lukuoikeus, ja ominaisuuksien käyttöoikeuksia hallitaan Widget-tason määrityksillä. Tavalliset käyttäjäryhmän oikeudet eivät koske Widget-käyttäjiä Media Kategorian käyttöoikeudet eivät. Jatka medialuokan käyttöoikeuksien määrittelyä.',
  widgetRefreshErrorMsg: 'Päivitä sivu nähdäksesi pyydetyn sisällön',
  widgetUserGroup: 'Widget-käyttäjäryhmä',
  widgetUserGroupDeleteMsg: 'Ei voi poistaa Widget-ryhmää käyttäjineen',
  willBeAffected: 'ovat kohteena.',
  willBeDeleted: '{content} poistetaan.',
  willBeInsertedIntoItem: '{name} lisätään kohteeseen {item}',
  willBeUpdated: 'päivitetään.',
  year: 'Vuosi',
  yourEmailAddress: 'Sähköpostiosoitteesi',
  zipCode: 'Postinumero',
  zoomHotpointToCanvas: 'Zoomaa Kohdepiste Alustan Kokoon',
  zoomIn: 'Lähennä',
  zoomOut: 'Loitonna'
};
/* eslint-enable max-len */
